import '../../resources/css/visual/VisualBlueprint.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { doActivePage } from '../../actions/menu/index';
import Loading from '../common/Loading';
import { Stage, Layer, Line, Transformer, Rect, Text, Image } from 'react-konva';
import Chip from '@mui/material/Chip';
import { checkTableAuth } from '../common/access-auth';
import { popupModalConfirm, openModalAlert, openPickModalWithAction, openModalTip, closeModal, openModal } from '../../actions/index';
import {
  getVisualGroupRSSIAction,
  getVisualGroupInteriorGraphAction,
  doGetHeatmapData,
  GET_HEATMAP_DATA_SUCCESS,
  doGetVisualData,
  GET_VISUAL_LIST_SUCCESS,
  dispathVisualMangerDetail,
  doSaveVisualGraphData,
  doGetAvaliableDeviceData,
  doGetVirtualDeviceData,
  SAVE_VIRTUAL_DEVICE_INFO_SUCCESS,
  GET_AVAILABLE_DEVICE_DATA_SUCCESS,
  doDeleteVirtualDeviceInfo,
  DELETE_VIRTUAL_DEVICE_SUCCESS,
  SAVE_GRAPH_DATA_SUCCESS,
  GET_VIRTUAL_DEVICE_DATA_SUCCESS,
  GET_VISUAL_GROUP_RSSI_INFO,
  doSaveScaleData,
  SAVE_SCALE_DATA_SUCCESS,
  SAVE_SCALE_DATA_FAIL,
  doGetHeatmapAllData,
  GET_HEATMAP_ALL_DATA_SUCCESS,
  doSaveChannelRecommendation,
  SAVE_CHANNEL_RECOMMENDATION_SUCCESS,
  SAVE_CHANNEL_RECOMMENDATION_FAIL,
  SAVE_VISUAL_MANAGER_DETAIL,
  DELETE_VISUAL_DATA_SUCCESS,
  doGetFloorDetail,
  doGetInteriorGraph,
  PRE_CHANGE_FLOOR_PLAN,
  continueToChangeFloorPlan,
  endChangingFloorPlan, doGetVisualDataId,
  doGetFloorPlanProjectList,
} from '../../actions/visual/index';
import { deviceDataSuccessAction } from '../../actions/device/index';
// import { getUploadFile } from '../../components/common/common-data';
// import Ruler from '../../components/common/Ruler';
// import apIcon from '../../resources/img/product-m-12@2x.png';
import mi10Img from '../../resources/img/product-mi10-icon.png';
import mi11Img from '../../resources/img/product-mi11-icon.png';
import mi12Img from '../../resources/img/product-m-12@3x.png';
import mi13Img from '../../resources/img/product-mi13-icon.png';
import mi14Img from '../../resources/img/product-mi14-icon.png';
import mi10Cursor from '../../resources/img/cursorIcon/product-mi10-icon.png';
import mi11Cursor from '../../resources/img/cursorIcon/product-mi11-icon.png';
import mi12Cursor from '../../resources/img/cursorIcon/product-m-12@3x.png';
import mi13Cursor from '../../resources/img/cursorIcon/product-mi13-icon.png';
import mi14Cursor from '../../resources/img/cursorIcon/product-mi14-icon.png';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Autocomplete
} from '@mui/material';
import RssiHeatMap from '../common/RssiHeatMap';
import _, { toInteger } from 'lodash';
import VirtualDeviceForm from './VirtualDeviceForm';
import { Button, Dropdown, Space, } from 'antd';
import 'antd/dist/antd.min.css';
import { DownOutlined } from '@ant-design/icons';
import PdfGenerator from "./VisualExport";
import {Col, OverlayTrigger, Popover, Row} from "react-bootstrap";

import SelectQuickFloorPlan from '../frame/SelectQuickFloorPlan';


let orgFilter;
let virtualIndex = 0;

// 2.4Ghz (PAF), 5Ghz (PAF), color, group category, material
const wallMaterial = {
  "brick": [12, 22, "rgba(255, 0, 0, 0.5)", "Brick", "brick"],
  "thick brick": [17, 26, "rgba(244, 64, 54, 0.5)", "Brick", "thick brick"],
  "concrete": [20, 23, "rgba(0, 128, 0, 0.5)", "Other", "concrete"],
  "foam materials": [2, 3, "rgba(255, 215, 0, 0.5)", "Other", "foam materials"],
  "wood": [2, 3, "rgba(173, 127, 83, 0.5)", "Wood", "wood"],
  "hard wood": [9, 14, "rgba(139, 69, 19, 0.5)", "Wood", "hard wood"],
  "glass": [5, 9, "rgba(64, 224, 208, 0.5)", "Glass", "glass"],
  "thick glass": [8, 11, "rgba(65, 105, 225, 0.5)", "Glass", "thick glass"],
  "bulletproof glass": [16, 21, "rgba(0, 0, 100, 0.5)", "Glass", "bulletproof glass"],
  "pillar": [26, 30, "rgba(128, 0, 128, 0.5)", "Other", "pillar"],
  "rolling steel door": [17, 22, "rgba(145, 139, 134, 0.5)", "Metal", "rolling steel door"],
  "steel plate": [20, 23, "rgba(161, 142, 69, 0.5)", "Metal", "steel plate"],
  "elevator": [30, 31, "rgba(61, 60, 56, 0.5)", "Metal", "elevator"],
  "signal blocking": [255, 255, "rgba(230, 126, 7, 0.5)", "Other", "signal blocking"],
  "steel mesh wall": [22, 25, "rgba(39, 84, 28, 0.5)", "Other", "steel mesh wall"],
  "metal studs with insulation and drywall": [14, 19, "rgba(255, 127, 80, 0.5)", "Other", "metal studs with insulation and drywall"],
  
};
const gamma = {
  'office': 2.55,
  'store': 2.2,
  'factory': 2.45,
  'home': 3,
  'free-space path loss': 2
}

const resolutionLevelArr = ["Very Low", "Low", "Medium", "High", "Very High", "Ultra High", "Extremely High"];

const modeInfoData = {
  "draw": "Left click to start drawing, Esc to cancel it. Hold Ctrl to drag. Release Ctrl to drawing continuously.",
  "erase": "Click line to erase it.",
  "scale": "Click the start and endpoints of the line and set the length.",
  "placingDevice": "Hold Ctrl to drag. Release Ctrl to place devices continuously."
}

// const mode = {
// 	Draw: "Draw",
// 	Drag: "Drag",
// 	Erase: "Erase",
// 	Scale: "Scale"
// }

class VisualBlueprint extends Component {

  constructor(props) {
    super(props);

    this.stageRef = React.createRef();
    this.lineLayerRef = React.createRef();
    this.transformerRef = React.createRef();
    this.imageRefs = [];

    this.zoomLevels = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500];
    this.currentZoomIndex = 7;
    this.timeoutId = null;
    this.autoChannelsOptions = {
      2442: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      5320: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165],
      5640: [100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165],
      8045: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97, 101, 105, 109, 113, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 233],
    }
    this.defaultChannelsForRecommendation = {
      2442: [1, 6, 11],
      5320: [36, 153, 157],
      5640: [149, 153, 161],
      8045: [5, 53, 85],
    }

    this.prevMode = null;
    this.visualRef = React.createRef();

    this.state = {
      initialImageWidth: 0,
      initialImageHeight: 0,
      scaleEnd: 0,
      showVirtualDeviceInfo: [],
      deviceList: null,
      dragMode: true,
      scale: 1,
      zoomPercentage: 100,
      showZoomPercentage: false,
      lines: [],
      isDrawing: false,
      selectedLine: null,
      eraseMode: false,
      drawMode: false,
      scaleMode: false,
      scaleLine: [],
      lineLength: 1,
      lineLengthYard: 1.0936,
      color: 'rgba(244, 67, 54, 0.5)',
      currentMaterial: 'brick',
      images: [],
      mi10Img: null,
      mi11Img: null,
      mi12Img: null,
      mi13Img: null,
      mi14Img: null,
      backgroundImg: null,
      heatMap: null,
      pdfHeatMap: [],
      heatmapImages: [],
      isSimulate: false,
      points: [],
      heatmapDataArrays: [],
      frequency: 2442,
      currentVirtualDevice: null,
      brickDropdownOpen: false,
      wifiCoverageDropdownOpen: false,
      channelRecommendationShow: false,
      channelRecommendation: {
        enabled: false,
        advanced: false,
        frequency: 2442,
        selectedChannels: {},
      },
      resolutionLevel: 3,
      deviceHistory: [],
      redoHistory: [],
      undoHistory: [],
      isRecover: false,
      simulateData: null,
      centerWidth: [(window.innerWidth - 100) / 2 - 320, 0, false],
      redirectPage: null,
      expectedWidth: 0,
      expectedHeight: 0,
      originalImageWidth: 0,
      originalImageHeight: 0,
      numberDevices: 0,
      inputError: false,
      unit: 'meter',
      scaleWindow: 1,
      positionMap: new Map(),
      selectedDevices: null,
      placingDeviceMode: false,
      isExporting: false,
      arrayIds: [],
      originalImageWidthArray: [],
      originalImageHeightArray: [],
      scaleArray: [],
      shouldReload: true,
    }

    this.resizeTimeout = null;
  }



  handleMouseDown = (e) => {
    if (e.evt?.button === 2) { // Right click
      return;
    }
    const { drawMode, scaleMode, undoHistory, placingDeviceMode } = this.state;
    const { offsetX, offsetY } = e.evt;
    const stage = this.lineLayerRef.current;
    const isLeftClick = e.evt.button === 0;
    const position = stage.getAbsolutePosition();
    const scale = stage.scaleX();
    const adjustedX = Math.round((offsetX - position.x) / scale);
    const adjustedY = Math.round((offsetY - position.y) / scale);

    // Catch the double click event 
    /* if (e.evt.detail === 2) {
      if (drawMode) {
        let updatedLines = this.state.lines;
        updatedLines.pop();
        this.setState({ lines: updatedLines });
        return;
      } else if (scaleMode) {
        // let updatedLines = this.state.scaleLine;
        // updatedLines.pop();
        // this.setState({ scaleLine: updatedLines });
        // console.log(this.state.scaleLine)
        return;
      }

    } else */if (this.state.isSimulate) {
      return;
    }

    if (this.state.eraseMode) {
      // Erase mode: remove lines with the clicked point
      if (this.state.selectedLine) {

        const updatedLines = this.state.lines.filter((line) => line !== this.state.selectedLine);
        console.log(this.state.selectedLine)
        let eraseLine = _.cloneDeep(this.state.selectedLine);
        eraseLine.type = 'erase';

        let history = _.cloneDeep(undoHistory);
        history.push(eraseLine);

        this.setState(() => ({
          undoHistory: history,
          lines: updatedLines,
          selectedLine: null,
          redoHistory: []
        }));
      }

    } else {
      // Drawing mode: start a new line
      if (drawMode) {
        let history = _.cloneDeep(this.state.undoHistory);

        // if (isRecover) {  // for undo
        //   history.splice(historyStep + 1, history.length - 1);
        // }

        const newLine = {
          points: [adjustedX, adjustedY, adjustedX, adjustedY],
          stroke: this.state.color,
          strokeWidth: 4,
          material: this.state.currentMaterial,
          paf: wallMaterial[this.state.currentMaterial][1],
          x: 0,
          y: 0,
          type: 'draw'
        };

        history.push(newLine)
        this.setState(() => ({
          lines: [...this.state.lines, newLine],
          undoHistory: history,
          isDrawing: true,
          selectedLine: null,
          isRecover: false
        }));
      } else if (scaleMode) {

        // Record the mouseDown is first or second
        this.setState((prevState) => ({ scaleEnd: ++prevState.scaleEnd }))
        const newLine = {
          points: [adjustedX, adjustedY, adjustedX, adjustedY],
          stroke: "#b00f0c",
          strokeWidth: 3,
          x: 0,
          y: 0
        };
        this.setState({
          scaleLine: this.state.scaleEnd % 2 === 0 ? [...this.state.scaleLine, newLine] : [newLine],
          isDrawing: !(this.state.scaleEnd % 2 === 0),
          selectedLine: null,
        });
      } else if (placingDeviceMode && isLeftClick) {
        this.addVirtualDevice(adjustedX, adjustedY)
      }

    }
  };

  handleMouseMove = (e) => {
    if (!this.state.isDrawing) return;
    const { drawMode, scaleMode } = this.state;
    const { offsetX, offsetY } = e.evt;
    const stage = this.lineLayerRef.current;
    const position = stage.getAbsolutePosition();
    const scale = stage.scaleX();
    const adjustedX = Math.round((offsetX - position.x) / scale);
    const adjustedY = Math.round((offsetY - position.y) / scale);

    if (drawMode) {
      const updatedLines = this.state.lines.slice();
      const lastLine = updatedLines[updatedLines.length - 1];
      lastLine.points = [...lastLine.points.slice(0, 2), adjustedX, adjustedY];
      this.setState({ lines: updatedLines });
    } else if (scaleMode) {
      const updatedLines = this.state.scaleLine.slice();
      const lastLine = updatedLines[updatedLines.length - 1];
      lastLine.points = [...lastLine.points.slice(0, 2), adjustedX, adjustedY];
      this.setState({ scaleLine: updatedLines });
    }


  };

  handleKeyDown = (e) => {
    const { drawMode, placingDeviceMode } = this.state;
    if (e.keyCode === 27) {
      if (drawMode && this.state.isDrawing) {
        let updatedLines = _.cloneDeep(this.state.lines)
        let historyLines = _.cloneDeep(this.state.undoHistory)
        updatedLines.pop();
        historyLines.pop();
        this.setState(() => ({ lines: updatedLines, undoHistory: historyLines }));
      }
      this.setState({ isDrawing: false });

    } else if (e.ctrlKey && (drawMode || placingDeviceMode)) {

      if (drawMode || placingDeviceMode) {
        this.prevMode = {
          drawMode,
          placingDeviceMode
        };

        this.setState({
          dragMode: true,
          drawMode: false,
          placingDeviceMode: false,
        });
      }
    }

  }

  handleKeyUp = (e) => {
    if (!e.ctrlKey && this.prevMode) {
      this.setState({
        ...this.prevMode,
        dragMode: false,
      });
      this.prevMode = null;
    }
  }

  handleDoubleClick = () => {
    // this.setState({ isDrawing: false });
  };

  handleLineClick = (line) => {
    this.setState({ selectedLine: line });
    // this.transformerRef.current?.nodes([line]);
  };

  handleMaterialChange = (e) => {
    this.setState({ currentMaterial: e.key, color: wallMaterial[e.key][2], eraseMode: false, drawMode: true, dragMode: false, scaleMode: false, brickDropdownOpen: false, placingDeviceMode: false });
  }


  handleImageDragEnd = (index, e) => {
    const { x, y } = e.target.attrs;
    let current = _.cloneDeep(this.state.currentVirtualDevice);
    let updatedImages = _.cloneDeep(this.state.showVirtualDeviceInfo);

    if (this.state.showVirtualDeviceInfo) {
      let history = _.cloneDeep(this.state.undoHistory);
      let rssiInfo = this.state.showVirtualDeviceInfo.map(option => ({
        ...option,
        x: option.x / this.state.scaleWindow,
        y: option.y / this.state.scaleWindow
      }));
      history.push({
        type: 'deviceList',
        data:  _.cloneDeep(rssiInfo)
      });

      this.setState(() => ({
        undoHistory: history,
        redoHistory: []
      }));
    }

    updatedImages[index].x = x + 7;
    updatedImages[index].y = y + 7;
    if (!_.isEmpty(current)) {
      current.x = x + 7;
      current.y = y + 7;
      this.setState({ currentVirtualDevice: current });
    }
    this.setState({ showVirtualDeviceInfo: updatedImages });   
    if (this.state.isSimulate) {
      this.getHeatmapData(this.state.frequency, this.state.resolutionLevel)
    }

    let deviceHistory = _.cloneDeep(this.state.deviceHistory);

    let updatedDeviceHistory = updatedImages.map(option => ({
      ...option,
      x: option.x / this.state.scaleWindow,
      y: option.y / this.state.scaleWindow
    }));

    deviceHistory.push({
      type: 'deviceList',
      data: updatedDeviceHistory
    });

    this.setState(() => ({
      deviceHistory: deviceHistory,
    }));
  };

  handleZoomIn = () => {
    if (this.currentZoomIndex < this.zoomLevels.length - 1) {
      this.currentZoomIndex++;
    }

    if (this.state.drawMode || this.state.placingDeviceMode) {
      this.visualRef.current?.focus();
    }
    this.handleZoom();
  };

  handleZoomOut = () => {
    if (this.currentZoomIndex > 0) {
      this.currentZoomIndex--;
    }

    if (this.state.drawMode || this.state.placingDeviceMode) {
      this.visualRef.current?.focus();
    }
    this.handleZoom();
  };

  handleZoom = () => {
    const newZoomPercentage = this.zoomLevels[this.currentZoomIndex];
    const newScale = newZoomPercentage / 100;

    clearTimeout(this.timeoutId);

    this.setState(() => ({
      scale: newScale,
      zoomPercentage: newZoomPercentage,
      showZoomPercentage: true,
    }));
  }


  handleUndo = () => {
    const { lines, undoHistory, redoHistory, deviceHistory } = this.state;
    let updatedLines = [...lines];
    if (undoHistory.length === 0) {
      if (this.state.drawMode || this.state.placingDeviceMode || this.state.isDrawing) {
        this.visualRef.current?.focus();
      }
      return;
    }
    if (this.state.drawMode || this.state.placingDeviceMode || this.state.isDrawing) {
      this.visualRef.current?.focus();
    }


    let currentUndo = undoHistory[undoHistory.length - 1];
    let updatedUndoHistory = _.cloneDeep(undoHistory)
    let updatedRedoHistory = _.cloneDeep(redoHistory)
    let updatedDeviceHistory = _.cloneDeep(deviceHistory)

    console.log(updatedUndoHistory)
    console.log(updatedRedoHistory)


    console.log("--------- UNDO -----------")



    if (currentUndo?.type === 'erase') {
      if (_.filter(updatedLines, ['points', currentUndo.points]).length === 0) {
        updatedLines.push(updatedUndoHistory[updatedUndoHistory.length - 1])
      }
    } else {
      updatedLines = updatedLines.filter((line) => line !== _.filter(updatedLines, ['points', currentUndo.points])[0]);
    }

    updatedRedoHistory.push(updatedUndoHistory[updatedUndoHistory.length - 1])
    updatedUndoHistory.pop();
    if(currentUndo?.type === 'deviceList') {
      updatedRedoHistory.push(updatedDeviceHistory[deviceHistory.length - 1])
      updatedDeviceHistory.pop();
    }


    console.log(updatedUndoHistory)
    console.log(updatedRedoHistory)

    if (currentUndo?.type === 'deviceList'){
      let updatedDevice = currentUndo.data.map(option => ({
        ...option,
        x: option.x * this.state.scaleWindow,
        y: option.y * this.state.scaleWindow
      }));
      this.setState(
        {
          showVirtualDeviceInfo: updatedDevice,
          isRecover: true,
          undoHistory: updatedUndoHistory,
          redoHistory: updatedRedoHistory,
          deviceHistory: updatedDeviceHistory,
        },
        () => {
          if (this.state.isSimulate) {
            this.getHeatmapData(this.state.frequency, this.state.resolutionLevel);
          }
        }
      );
    } else {
      this.setState(
        {
          lines: updatedLines,
          isRecover: true,
          redoHistory: updatedRedoHistory,
          undoHistory: updatedUndoHistory
        },
        () => {
          if (this.state.isSimulate) {
            this.getHeatmapData(this.state.frequency, this.state.resolutionLevel);
          }
        }
      );
    }
  }

  handleRedo = () => {

    // in redo, if it has erase property, eg. draw line
    // in undo, if it has erase property, eg. remove line

    const { lines, undoHistory, redoHistory, deviceHistory } = this.state;
    if (redoHistory.length === 0) {
      if (this.state.drawMode || this.state.placingDeviceMode) {
        this.visualRef.current?.focus();
      }
      return;
    }

    if (this.state.drawMode || this.state.placingDeviceMode) {
      this.visualRef.current?.focus();
    }

    console.log("--------- REDO -----------")


    let updatedLines = [...lines];


    let currentRedo = redoHistory[redoHistory.length - 1];
    let updatedRedoHistory = _.cloneDeep(redoHistory)
    let updatedUndoHistory = _.cloneDeep(undoHistory)
    let updatedDeviceHistory = _.cloneDeep(deviceHistory)


    if (currentRedo?.type === 'erase') {
      updatedLines = updatedLines.filter((line) => line !== _.filter(updatedLines, ['points', currentRedo.points])[0]);
    } else {
      if (_.filter(updatedLines, ['points', currentRedo.points]).length === 0) {
        updatedLines.push(updatedRedoHistory[updatedRedoHistory.length - 1]);
      }
    }

    if(currentRedo?.type === 'deviceList') {
      updatedDeviceHistory.push(updatedRedoHistory[updatedRedoHistory.length - 1]);
      updatedRedoHistory.pop();
    }
    
    updatedUndoHistory.push(updatedRedoHistory[updatedRedoHistory.length - 1]);
    updatedRedoHistory.pop();


    console.log(updatedUndoHistory)
    console.log(updatedRedoHistory)

    if (currentRedo?.type === 'deviceList'){
      let updatedDevice = currentRedo.data.map(option => ({
        ...option,
        x: option.x * this.state.scaleWindow,
        y: option.y * this.state.scaleWindow
      }));
      this.setState(
        {
          showVirtualDeviceInfo: updatedDevice,
          isRecover: true,
          undoHistory: updatedUndoHistory,
          redoHistory: updatedRedoHistory,
          deviceHistory: updatedDeviceHistory,
        },
        () => {
          if (this.state.isSimulate) {
            this.getHeatmapData(this.state.frequency, this.state.resolutionLevel);
          }
        }
      );
    } else {
      this.setState(
        {
          lines: updatedLines,
          isRecover: true,
          redoHistory: updatedRedoHistory,
          undoHistory: updatedUndoHistory
        },
        () => {
          if (this.state.isSimulate) {
            this.getHeatmapData(this.state.frequency, this.state.resolutionLevel);
          }
        }
      );
    }
  }

  handleHeatmapToggle = () => {
    const { isSimulate, frequency, resolutionLevel } = this.state;

    if (!isSimulate) {
      this.getHeatmapData(frequency, resolutionLevel);
      this.setState({ isSimulate: !isSimulate, wifiCoverageDropdownOpen: false });
    } else {
      this.setState({ heatMap: null, isSimulate: !isSimulate, wifiCoverageDropdownOpen: false });
    }
  }

  handlePDFHeatmap = () => {
    const { frequency, resolutionLevel } = this.state;
    this.getHeatmapDataAll(frequency, resolutionLevel);
  }

  handleHeatmapImage = (img, id) => {
    if (img) {
      const image = new window.Image();
      image.src = img
      image.onload = () => {
        this.setState({ heatMap: image });
      };
    }
  }

  handlePDFHeatmapImage = async (img, id) => {
    if (img) {
      const image = new window.Image();
      image.src = img;
      image.onload = () => {
        this.setState(prevState => ({
          pdfHeatMap: [...prevState.pdfHeatMap, { image, id }]
        }))
      };
    }
  }

  handleDeleteVirtualDevice = (virtualDevice) => {
    const { authToken, doDeleteVirtualDeviceInfo, popupModalConfirm } = this.props;
    let deviceCount = this.state.numberDevices;

    popupModalConfirm('Delete', 'icon-ico-failed', 'Are you sure you want to remove this device?', 300, () => {
      let virtualLst
      if (virtualDevice?.seq) {
        doDeleteVirtualDeviceInfo(authToken, virtualDevice.seq);
        virtualLst = _.remove(this.state.showVirtualDeviceInfo, function (e) {
          return e?.seq !== virtualDevice.seq
        })
      } else {
        virtualLst = _.remove(this.state.showVirtualDeviceInfo, function (e) {
          return e?.virtualIndex !== virtualDevice.virtualIndex
        })
      }
      this.setState({ showVirtualDeviceInfo: virtualLst, currentVirtualDevice: null });
      deviceCount--
      this.setState({numberDevices: deviceCount});
    }, null, false);

  }

  convertTxpowerValue = (value, powerDbmIndex) => {
    const txpowerMax = powerDbmIndex === 1 || powerDbmIndex === 2 ? 21 : powerDbmIndex === 3 ? 30 : 22;
    const txpowerMin = powerDbmIndex === 0 || powerDbmIndex === 1 || powerDbmIndex === 2 ? 3 : 7;
    switch (value) {
      case 10:
        return Math.max(txpowerMax - 10, txpowerMin);
      case 25:
        return Math.max(txpowerMax - 6, txpowerMin);
      case 50:
        return Math.max(txpowerMax - 3, txpowerMin);
      case 75:
        return Math.max(txpowerMax - 1, txpowerMin);
      case 100:
        return Math.max(txpowerMax, txpowerMin);
      default:
        return 0;
    }
  }

  getHeatmapData(frequency, resolutionLevel) {
    const { doGetHeatmapData, authToken, selectFloorPlanProjectEnvironment } = this.props;
    const { showVirtualDeviceInfo, lines, scaleLine, lineLength, originalImageWidth, originalImageHeight, channelRecommendation } = this.state;

    let wt = [], wall = [];
    const powerDbmIndex = frequency === 2442 ? 0 : frequency === 5320 ? 1 : frequency === 5640 ? 2 : 3;

    // Create the wt(ap) array
    let index = 0;
    showVirtualDeviceInfo.forEach((e) => {
      const apData = {
        "power_dbm": this.convertTxpowerValue(e.powerDbm[powerDbmIndex], powerDbmIndex),
        "position": [parseInt(e.x), parseInt(e.y)],
        "model_name": e.modelName,
        "rotation_angle": e.rotationAngle,
        "device_placement": e.devicePlacement,
        "wt_index": index++,
      }
      if (apData.power_dbm !== 0 && apData.position.every(e => e >= 0)
          && apData.position[0] < toInteger(originalImageWidth)
          && apData.position[1] < toInteger(originalImageHeight)
      ) {
        wt.push(apData);
      }
    });

    // Create the wall array
    for (let e of lines) {
      const [x1, y1, x2, y2] = e.points;
      const [offsetX, offsetY] = [e.x, e.y];
      const pafIndex = frequency === 2442 ? 0 : 1;
      const wallData = {
        "position": [[x1 + offsetX, y1 + offsetY], [x2 + offsetX, y2 + offsetY]],
        "material": e.material,
        "PAF": wallMaterial[e.material][pafIndex]
      }
      wall.push(wallData);
    }

    const [x1scale, y1scale, x2scale, y2scale] = scaleLine[0]?.points ?? [1, 1, 2, 2];
    const linePX = Math.sqrt((x2scale - x1scale) ** 2 + (y2scale - y1scale) ** 2);
    const ppm = linePX / lineLength;
    const use_omi_parttern = true;

    // console.log(ppm)

    // Create the data object for heatmap api 
    const data = {
      "gamma": gamma[selectFloorPlanProjectEnvironment], // 1-10
      "ppm": ppm,
      "freq_MHz": frequency, // 1000-360000
      // "image_height": 500,
      // "image_width": 700,
      "image_height": toInteger(originalImageHeight),
      "image_width": toInteger(originalImageWidth),
      "wt": wt,
      "wall": wall,
      "blur_level": 3,
      "resolution_level": resolutionLevelArr[resolutionLevel],
      "use_omni_pattern": use_omi_parttern
      // "multipath": {
      //   "using_multipath": false,
      //   "pseudo_K": 35,
      //   "lower_bound": -90

      // } 
    }

    let autoChannelRecommendation = null
    if (channelRecommendation.enabled) {
      if (channelRecommendation.advanced) {
        const channelsLength = channelRecommendation.selectedChannels[frequency].length
        if (channelsLength > 1) {
          autoChannelRecommendation = {
            "enable": true,
            "n_channels": channelRecommendation.selectedChannels[frequency].length,
          }
        }
      } else {
        autoChannelRecommendation = {
          "enable": true,
          "n_channels": this.defaultChannelsForRecommendation[frequency].length,
        }
      }
    }

    if (autoChannelRecommendation) {
      data.auto_channel_recommend = autoChannelRecommendation;
    }

    // Convert data object to json file
    const jsonData = JSON.stringify(data);
    // console.log(data);
    console.info(jsonData);

      // Optimize the heatmap function, if there did not change any other graph information, we won't call HeatMap API again. 
    this.setState({ points: [] })
    const blob = new Blob([jsonData], { type: 'application/json' });

      // Create a FormData object and append the blob as a file
    const formData = new FormData();
    formData.append('user_parameters', blob, 'data.json');

    doGetHeatmapData(formData, authToken);

  }

  getHeatmapDataAll(frequency, resolutionLevel) {
    const { doGetHeatmapAllData, authToken, selectFloorPlanProjectEnvironment, selectFloorPlanProject, mappingInteriorGraph } = this.props;
    const { showVirtualDeviceInfo, lines, scaleLine, lineLength, simulateData, originalImageWidth, originalImageHeight } = this.state;

    this.setState({ pdfHeatMap: [] });
    let wt = [], wall = [];
    const powerDbmIndex = frequency === 2442 ? 0 : frequency === 5320 ? 1 : frequency === 5640 ? 2 : 3;

    showVirtualDeviceInfo.forEach((e) => {
      const apData = {
        "power_dbm": this.convertTxpowerValue(e.powerDbm[powerDbmIndex], powerDbmIndex),
        "position": [parseInt(e.x), parseInt(e.y)],
        "model_name": e.modelName,
        "rotation_angle": e.rotationAngle,
        "device_placement": e.devicePlacement
      }
      if (apData.power_dbm !== 0 && apData.position.every(e => e >= 0)
        && apData.position[0] < toInteger(originalImageWidth)
        && apData.position[1] < toInteger(originalImageHeight)
    ) {
      wt.push(apData);
    }
    });

    for (let e of lines) {
      const [x1, y1, x2, y2] = e.points;
      const [offsetX, offsetY] = [e.x, e.y];
      const pafIndex = frequency === 2442 ? 0 : 1;
      const wallData = {
        "position": [[x1 + offsetX, y1 + offsetY], [x2 + offsetX, y2 + offsetY]],
        "material": e.material,
        "PAF": wallMaterial[e.material][pafIndex]
      }
      wall.push(wallData);
    }

    const [x1scale, y1scale, x2scale, y2scale] = scaleLine[0]?.points ?? [1, 1, 2, 2];
    const linePX = Math.sqrt((x2scale - x1scale) ** 2 + (y2scale - y1scale) ** 2);
    const ppm = linePX / lineLength;
    const use_omi_parttern = true;

    const data = {
      "gamma": gamma[selectFloorPlanProjectEnvironment], // 1-10
      "ppm": ppm,
      "freq_MHz": frequency, // 1000-360000
      "image_height": toInteger(originalImageHeight),
      "image_width": toInteger(originalImageWidth),
      "wt": wt,
      "wall": wall,
      "blur_level": 3,
      "resolution_level": resolutionLevelArr[resolutionLevel],
      "use_omni_pattern": use_omi_parttern
    }

    // Convert data object to json file
    const jsonData = JSON.stringify(data);
    console.info(jsonData);
    if (jsonData !== simulateData) {
      // Optimize the heatmap function, if there did not change any other graph information, we won't call HeatMap API again. 
      this.setState({ simulateData: jsonData, points: [] })
      const blob = new Blob([jsonData], { type: 'application/json' });

      // Create a FormData object and append the blob as a file
      const formData = new FormData();
      formData.append('user_parameters', blob, 'data.json');

      doGetHeatmapAllData(authToken, selectFloorPlanProject, mappingInteriorGraph.id, formData);
    }
  }

  convertBase64StringToPointArray() {
    const { heatmapData } = this.props;

    let pointArray = [];
    // Decode the base64 string to a Uint8Array
    const uint8Array = new Uint8Array([...atob(heatmapData.base64_str)].map(char => char.charCodeAt(0)));

    // Create a Float64Array from the decoded Uint8Array
    const float64Array = new Float64Array(uint8Array.buffer);

    // Determine the number of columns in the original array
    const numColumns = heatmapData.width;

    // Create the 2D array and populate it with the decoded values
    const decodedArray = Array.from({ length: float64Array.length / numColumns }, (_, rowIndex) =>
      Array.from({ length: numColumns }, (_, columnIndex) => float64Array[rowIndex * numColumns + columnIndex])
    );


    decodedArray.forEach((row, rowIndex) => {
      row.forEach((value, colIndex) => {
        const point = { x: colIndex, y: rowIndex, value };
        pointArray.push(point);
      });
    });

    this.setState({ points: pointArray })
  }

  convertBase64StringToPointArrayAll() {
    const { heatmapAllData } = this.props;
    
    if (!heatmapAllData || !Array.isArray(heatmapAllData)) {
      return;
    }

    const allArrays = heatmapAllData.map(heatmapData => {
      let pointArray = [];
      // Decode the base64 string to a Uint8Array
      const uint8Array = new Uint8Array([...atob(heatmapData.base64_str)].map(char => char.charCodeAt(0)));

      // Create a Float64Array from the decoded Uint8Array
      const float64Array = new Float64Array(uint8Array.buffer);

      // Determine the number of columns in the original array
      const numColumns = heatmapData.width;

      // Create the 2D array and populate it with the decoded values
      const decodedArray = Array.from({ length: float64Array.length / numColumns }, (_, rowIndex) =>
        Array.from({ length: numColumns }, (_, columnIndex) => float64Array[rowIndex * numColumns + columnIndex])
      );

      decodedArray.forEach((row, rowIndex) => {
        row.forEach((value, colIndex) => {
          const point = { x: colIndex, y: rowIndex, value };
          pointArray.push(point);
        });
      });

      return {
        points: pointArray,
        graphId: heatmapData.graphId,
        width: heatmapData.width,
        height: heatmapData.height,
        scale: heatmapData.scale,
      };
    });

    this.setState({ heatmapDataArrays: allArrays });
  }

  checkGraphIsChange = () => {
    const { mappingInteriorGraph, wallInfo, deviceVirtualList } = this.props;
    const { lines, scaleWindow } = this.state;


    const wallData = lines?.map((e) => ({
      ...e,
      points: e.points.map(p => Math.round(p / scaleWindow)).join()
    }))
    const scaleLineData = this.state.scaleLine[0].points;

    let rssiInfo = this.state.showVirtualDeviceInfo
    rssiInfo = rssiInfo.map(option => ({
      ...option,
      x: Math.round(option.x / scaleWindow),
      y: Math.round(option.y / scaleWindow)
    }));

    const isGraphNotChanged = _.isEqual(wallInfo, wallData)
        && _.isEqual(deviceVirtualList, rssiInfo)
        && _.isEqual(mappingInteriorGraph.scaleLine, scaleLineData.join())
        && _.isEqual(mappingInteriorGraph.scale, (this.state.lineLength))
        && this.isChannelRecommendationNotChanged();
    // console.log(_.isEqual(visualGraph.wallInfo, wallData))
    // console.log(_.isEqual(visualGraph.rssiInfo, showVirtualDeviceInfo))
    // console.log(_.isEqual(visualGraph.interiorGraph.scaleLine, scaleLineData.join()))
    // console.log(_.isEqual(visualGraph.interiorGraph.scale, parseInt(this.state.lineLength)))
    return !isGraphNotChanged;
    // return true;

  }

  isChannelRecommendationNotChanged = () => {
    const { channelRecommendation } = this.state;
    const { mappingInteriorGraph } = this.props;
    return channelRecommendation.enabled === mappingInteriorGraph.channelRecommendationEnabled
        && channelRecommendation.advanced === mappingInteriorGraph.advancedChannelRecommendation
        && _.isEqual(channelRecommendation.selectedChannels[2442], mappingInteriorGraph.band24GHzChannels)
        && _.isEqual(channelRecommendation.selectedChannels[5320], mappingInteriorGraph.band5GHz1Channels)
        && _.isEqual(channelRecommendation.selectedChannels[5640], mappingInteriorGraph.band5GHz2Channels)
        && _.isEqual(channelRecommendation.selectedChannels[8045], mappingInteriorGraph.band6GHzChannels);
  }

  handleUnitChange = (event) => {
    const selectedUnit = event.target.value;
    localStorage.setItem("selectedUnit", selectedUnit);
    this.setState({ unit: selectedUnit });
  };

  setStateLengthYard(value) {
    this.setState({ lineLengthYard: value });
    if (isNaN(Number(value))) {
      this.setState({ lineLength: value });
    }
    else {
      this.setState({ lineLength: this.convertYardToMeter(value) });
    }
  }

  setStateLengthMeter(value) {
    this.setState({ lineLength: value });
    if (isNaN(Number(value))) {
      this.setState({ lineLengthYard: value });
    }
    else {
      this.setState({ lineLengthYard: this.convertMeterToYard(value) });
    }
  }

  convertMeterToYard(value) {
    return (Number(value) * 1.09361).toFixed(2);
  }

  convertYardToMeter(value) {
    return (Number(value) / 1.09361).toFixed(2);
  }

  saveGraphData = (isLeave) => {
    const { popupModalConfirm, accountRole, roleTableAuth, openModalAlert, authToken, mappingInteriorGraph, doSaveVisualGraphData, graphId } = this.props;
    const { lines, scaleWindow, undoHistory, redoHistory, deviceHistory, channelRecommendation } = this.state;
    const wallData = lines?.map((e) => ({
      ...e,
      points: e.points.map(p => Math.round(p / scaleWindow)).join()
    }))
    const scaleLine = this.state.scaleLine[0].points;
    let deviceData = this.state.showVirtualDeviceInfo.map(e => ({
      ...e,
      x: e.x / scaleWindow,
      y: e.y / scaleWindow,
      powerDbm2g: e.powerDbm[0],
      powerDbm5g1: e.powerDbm[1],
      powerDbm5g2: e.powerDbm[2],
      powerDbm6g: e.powerDbm[3],
    }))

    localStorage.setItem("graphId", graphId);
    localStorage.setItem("undoHistory", JSON.stringify(_.cloneDeep(undoHistory)));
    localStorage.setItem("redoHistory", JSON.stringify(_.cloneDeep(redoHistory)));
    localStorage.setItem("deviceHistory", JSON.stringify(_.cloneDeep(deviceHistory)));


    if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
      // Check whether the changes of this floor plan graph or not
      if (this.checkGraphIsChange()) {
        const isValidInteger = Number(this.state.lineLength) > 0;
        if (channelRecommendation.advanced) {
          const selectedChannels = channelRecommendation.selectedChannels;
          for (const frequency in selectedChannels) {
            if (selectedChannels[frequency].length < 2) {
              openModalAlert('Please select at least 2 channels in Wi-Fi band ' + (frequency === '2442' ? '2.4GHz' : frequency === '5320' ? '5GHz-1' : frequency === '5640' ? '5GHz-2' : '6GHz'),
                  'Channel Recommendation', () => this.setState({ channelRecommendationShow: true }));
              return false;
            }
          }
        }
        if (isValidInteger) {
          if (isLeave) {
            doSaveVisualGraphData(authToken, wallData, mappingInteriorGraph.id, this.state.lineLength, scaleLine.join(), deviceData.map(e => _.omit(e, ['powerDbm'])), this.getChannelRecommendationConfig());
          } else {
            popupModalConfirm('Confirm', 'icon-alert', 'Confirm to change?', 300, () => {
              doSaveVisualGraphData(authToken, wallData, mappingInteriorGraph.id, this.state.lineLength, scaleLine.join(), deviceData.map(e => _.omit(e, ['powerDbm'])), this.getChannelRecommendationConfig());
            }, null, false);
          }

        } else {
          openModalAlert("The line length (scale) value is invalid.");
          return false;
        }
      }
      else {
        openModalAlert("No save change.")
        return true;
      }
    } else {
      openModalAlert("Sorry you don't have permission to change config.");
      return true;
    }
    return true;
  }


  renderDevices = (rssiInfo) => {
    const { dragMode, channelRecommendation, frequency, isSimulate } = this.state;
    let { recommendedChannels } = this.props;
    recommendedChannels = recommendedChannels ?? []
    const recommendedChannelByIndex = recommendedChannels.reduce((acc, obj) => {
      acc[obj.wt_index] = obj;
      return acc;
    }, {});
    const selectedChannels = channelRecommendation.advanced ? channelRecommendation.selectedChannels[frequency]
        : this.defaultChannelsForRecommendation[frequency];
    const channelRecommendationEnabled = channelRecommendation.enabled && isSimulate
    return Array.from(rssiInfo).map((option, index) => {
      const recommendedChannel = recommendedChannelByIndex[index]
      return (<React.Fragment key={index}>
        {/* Add a Rect shape for the Text background */}
        {
            channelRecommendationEnabled && recommendedChannel && (<>
              <Rect
                  x={option.x + 15}
                  y={option.y - 7}
                  width={24}
                  height={15}
                  fill="#7a6dec"
                  cornerRadius={5}
                  zindex={9998}
              />
              <Text
                  text={selectedChannels[recommendedChannel.channel_index] ?? selectedChannels[0]}
                  x={option.x + 18}
                  y={option.y - 4}
                  fontSize={10}
                  fill="#ffffff"
                  zindex={9999}
              />
            </>)
        }
        <Rect
          x={option.x - 20}
          y={option.y + 18}
          width={50}
          height={15}
          fill="lightgray"
          cornerRadius={5}
          onClick={() => {
            this.setState({ currentVirtualDevice: option });
          }}
        />
        {/* Add the Text component */}
        <Text
          text={option.name.length > 7 ? option.name.slice(0, 6) + "..." : option.name}
          x={option.x - 15}
          y={option.y + 21}
          fontSize={10}
          onClick={() => {
            this.setState({ currentVirtualDevice: option });
          }}
        />

        {/* Add the Image component */}
        <Image
          key={index}
          image={this.getImage(option.modelName)}
          x={option.x - 7}
          y={option.y - 7}
          width={15}
          height={15}
          draggable={dragMode}
          onDragEnd={(e) => { e.cancelBubble = true; this.handleImageDragEnd(index, e) }}
          onClick={(e) => { this.setState({ currentVirtualDevice: null }); this.setState({ currentVirtualDevice: option }); this.handleImageDragEnd(index, e); }}
          ref={(node) => (this.imageRefs[index] = node)}
        />


      </React.Fragment>)

    });
  }

  addVirtualDevice = (adjustX, adjustY) => {
    const { mappingOrg, mappingGroup } = this.props;
    const { selectedDevices } = this.state;
    let deviceCount = this.state.numberDevices;
    let newlst = this.state.showVirtualDeviceInfo;
    let power5ghz2 = selectedDevices.key === "MI10" ? 100 : 0;
    let power6ghz = selectedDevices.key === "MI11" ? 100 : 0;

    const newVirtualDevice = {
      "powerDbm": [
        100,
        100,
        power5ghz2,
        power6ghz
      ],
      "deviceMac": null,
      "site": mappingOrg,
      "name": selectedDevices.key,
      "x": adjustX,
      "y": adjustY,
      "rotationAngle": 0,
      "group": mappingGroup,
      "modelName": selectedDevices.key,
      "devicePlacement": "prone",
      "virtualIndex": virtualIndex++
    }

    let history = _.cloneDeep(this.state.undoHistory);
    let currentDevices = this.state.showVirtualDeviceInfo.map(device => ({
      ...device,
      x: device.x / this.state.scaleWindow,
      y: device.y / this.state.scaleWindow
    }));

    history.push({
      type: 'deviceList',
      data: currentDevices
    })

    this.setState({
      undoHistory: history,
      redoHistory: []
    });

    newlst.push(newVirtualDevice);

    let deviceHistory = _.cloneDeep(this.state.deviceHistory);

    let updatedDevice = newlst.map(device => ({
      ...device,
      x: device.x / this.state.scaleWindow,
      y: device.y / this.state.scaleWindow
    }));

    deviceHistory.push({
      type: 'deviceList',
      data: updatedDevice
    });

    this.setState({
      deviceHistory: deviceHistory
    });

    this.setState({ showVirtualDeviceInfo: newlst });
    deviceCount++
    this.setState({numberDevices: deviceCount});

  }

  getInteriorImage = (isFloorPlanChanged) => {
    const { mappingInteriorGraph, getVisualGroupInteriorGraphAction } = this.props;
    const { showVirtualDeviceInfo, lines } = this.state;
    if (mappingInteriorGraph.interiorImg) {
      const img = new window.Image();
      img.src = `data:image/png;base64,${mappingInteriorGraph?.interiorImg}`;

      img.onload = () => {
        const trueImgWidth = img.width;
        const trueImgHeight = img.height;

        if (!isNaN(trueImgWidth) && !isNaN(trueImgHeight) && trueImgWidth > 0 && trueImgHeight > 0) {
          let originalAspectRatio = trueImgWidth / trueImgHeight;
          
          let containerHeight = (window.innerHeight - 210) ?? window.Konva.stages[0]?.bufferCanvas?.height;
          let containerWidth = (window.innerWidth ?? window.Konva.stages[0]?.bufferCanvas?.width) - 180;

          if(containerWidth < 800) {
            containerWidth = 800;
          }

          if(containerHeight < 500) {
            containerHeight = 500;
          }

          let currentScaleWindow;
          let displayImageWidth;
          let displayImageHeight;

          if (trueImgWidth <= containerWidth && trueImgHeight <= containerHeight) {
            displayImageWidth = trueImgWidth;
            displayImageHeight = trueImgHeight;
            currentScaleWindow = 1;
          } else {
            if (originalAspectRatio > (containerWidth / containerHeight)) {
              currentScaleWindow = containerWidth / trueImgWidth;
            } else {
              currentScaleWindow = containerHeight / trueImgHeight;
            }
            displayImageWidth = Math.round(trueImgWidth * currentScaleWindow);
            displayImageHeight = Math.round(trueImgHeight * currentScaleWindow);
          }
          
          let wallDataFromProps = [];
          if (this.props.wallInfo?.length > 0) {
            wallDataFromProps = this.props.wallInfo.map((e) => ({
              ...e,
              points: e.points.split(",").reduce((z, x) => z.concat(+x ), [])
            }));
          }
          let rssiInfoFromProps = _.cloneDeep(this.props.virtualDeviceInfo);

          if (currentScaleWindow !== 1 && isFloorPlanChanged) {
            wallDataFromProps = wallDataFromProps.map(wall => ({
              ...wall,
              points: wall.points.map(point => point * currentScaleWindow)
            }));
            rssiInfoFromProps = rssiInfoFromProps.map(option => ({
              ...option,
              x: option.x * currentScaleWindow,
              y: option.y * currentScaleWindow
            }));
          }

          this.setState({
            initialImageWidth: trueImgWidth,
            initialImageHeight: trueImgHeight,
            backgroundImg: img,
            expectedWidth: containerWidth,
            expectedHeight: containerHeight,
            originalImageWidth: displayImageWidth,
            originalImageHeight: displayImageHeight,
            lines: isFloorPlanChanged ? wallDataFromProps : lines,
            showVirtualDeviceInfo: isFloorPlanChanged ? rssiInfoFromProps : showVirtualDeviceInfo,
            scaleWindow: currentScaleWindow,
          });
        }

        getVisualGroupInteriorGraphAction(`url('data:image/png;base64,${mappingInteriorGraph?.interiorImg}')`, 500);
      };
    } else {
      this.setState({ 
        backgroundImg: null,
        initialImageWidth: 0,
        initialImageHeight: 0,
        originalImageWidth: 0,
        originalImageHeight: 0,
        scaleWindow: 1,
      });
    }
  }

  loadImages = () => {
    this.loadImage('mi10Img', mi10Img)
    this.loadImage('mi11Img', mi11Img)
    this.loadImage('mi12Img', mi12Img)
    this.loadImage('mi13Img', mi13Img)
    this.loadImage('mi14Img', mi14Img)
  };

  loadImage = (field, imgSrc) => {
    const img = new window.Image();
    img.src = imgSrc;

    img.onload = () => {
      this.setState({
        [field]: img,
      });
    };
  }

  getImage = (apKey) => {
    switch (apKey) {
      case 'MI10':
        return this.state.mi10Img
      case 'MI11':
        return this.state.mi11Img
      case 'MI12':
        return this.state.mi12Img
      case 'MI13':
        return this.state.mi13Img
      case 'MI14':
        return this.state.mi14Img
      default:
        return null
    }
  }

  closeVirtualDeviceForm = () => {
    this.setState({ currentVirtualDevice: null });
  }

  reInitGraphData = () => {
    const { virtualDeviceInfo, wallInfo, mappingInteriorGraph } = this.props;
    if (virtualDeviceInfo) {
      let wallData = [];
      if (wallInfo?.length > 0) {
        wallData = wallInfo.map((e) => ({
          ...e,
          points: e.points.split(",").reduce((z, x) => z.concat(+x), [])
        }))
      }

      const channelRecommendation = this.getCurrentChannelRecommendation()

      this.setState({
        lineLength: mappingInteriorGraph.scale,
        lineLengthYard: this.convertMeterToYard(mappingInteriorGraph.scale),
        scaleLine: [{
          points: mappingInteriorGraph.scaleLine.split(",").reduce((z, x) => z.concat(+x), []),
          stroke: "#b00f0c",
          strokeWidth: 3,
          x: 0,
          y: 0
        }],
        channelRecommendation: channelRecommendation,
        showVirtualDeviceInfo: _.cloneDeep(virtualDeviceInfo),
        lines: wallData,
        currentVirtualDevice: null,
      })
    }
  }

  saveUndoAndRedo() {
    const undoHistory = localStorage.getItem("undoHistory");
    const redoHistory = localStorage.getItem("redoHistory");

    let savedUndo = JSON.parse(undoHistory);
    let savedRedo = JSON.parse(redoHistory);

    if (undoHistory) {
      savedUndo = savedUndo.filter(item => item.type === "deviceList");
    }

    if (redoHistory) {
      savedRedo = savedRedo.filter(item => item.type === "deviceList");
    }

    const savedDeviceHistory = localStorage.getItem("deviceHistory");
  
    this.setState({ 
      undoHistory: savedUndo ? savedUndo : [],
      redoHistory: savedRedo ? savedRedo : [],
      deviceHistory: savedDeviceHistory ? JSON.parse(savedDeviceHistory) : [],
    });
  }

  componentDidMount() {
    const { virtualDeviceInfo, mappingInteriorGraph, selectSite, doGetAvaliableDeviceData, authToken, graphId } = this.props;
    doGetVirtualDeviceData(authToken, graphId);
    this.loadImages();

    window.addEventListener('wheel', this.handleWheelZoom, { passive: false });
    window.addEventListener('keydown', this.handleKeyZoom);

    const savedUnit = localStorage.getItem("selectedUnit");
    if (savedUnit) {
      this.setState({ unit: savedUnit });
    }

    if (mappingInteriorGraph) {
      this.getInteriorImage(true);
    }

    if (virtualDeviceInfo) {
      this.displayDeviceCount();
      this.saveUndoAndRedo();
      const channelRecommendation = this.getCurrentChannelRecommendation()

      this.setState({
        lineLength: mappingInteriorGraph.scale,
        lineLengthYard: this.convertMeterToYard(mappingInteriorGraph.scale),
        scaleLine: [{
          points: mappingInteriorGraph.scaleLine.split(",").reduce((z, x) => z.concat(+x), []),
          stroke: "#b00f0c",
          strokeWidth: 3,
          x: 0,
          y: 0
        }],
        channelRecommendation: channelRecommendation,
      })
    }

    localStorage.removeItem("undoHistory");
    localStorage.removeItem("redoHistory");
    localStorage.removeItem("deviceHistory");
    orgFilter = selectSite;
    doGetAvaliableDeviceData(authToken, 0, orgFilter);

    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('wheel', this.handleWheelZoom);
    window.removeEventListener('keydown', this.handleKeyZoom);
    clearTimeout(this.resizeTimeout);
  }

  handleWheelZoom = (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  }

  handleKeyZoom = (e) => {
    if (e.ctrlKey && (e.key === '+' || e.key === '-' || e.key === '0' || e.key === '=')) {
      e.preventDefault();
    }
  }
  
  updateDimensions = () => {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      const { initialImageWidth, initialImageHeight, lines, showVirtualDeviceInfo, scaleWindow: oldScaleWindow } = this.state;
      
      if (!isNaN(initialImageWidth) && !isNaN(initialImageHeight) && initialImageWidth > 0 && initialImageHeight > 0) {
        // Calculate container dimensions
        let containerHeight = (window.innerHeight - 210) ?? window.Konva.stages[0]?.bufferCanvas?.height;
        let containerWidth = (window.innerWidth ?? window.Konva.stages[0]?.bufferCanvas?.width) - 180;

        if (containerWidth < 800) {
          containerWidth = 800;
        }

        if(containerHeight < 500) {
          containerHeight = 500;
        }

        const originalAspectRatio = initialImageWidth / initialImageHeight;
        let newScaleWindow;

        if (initialImageWidth <= containerWidth && initialImageHeight <= containerHeight) {
            newScaleWindow = 1;
        } else {
            if (originalAspectRatio > (containerWidth / containerHeight)) {
                newScaleWindow = containerWidth / initialImageWidth;
            } else {
                newScaleWindow = containerHeight / initialImageHeight;
            }
        }


        const newDisplayImageWidth = initialImageWidth * newScaleWindow;
        const newDisplayImageHeight = initialImageHeight * newScaleWindow;

        let newLines = lines;
        let newShowVirtualDeviceInfo = showVirtualDeviceInfo;

        if (oldScaleWindow !== newScaleWindow && oldScaleWindow !== 0 && oldScaleWindow !== undefined) {
            const relativeScaleChange = newScaleWindow / oldScaleWindow;
            newLines = lines.map(line => ({
                ...line,
                points: line.points.map(p => p * relativeScaleChange)
            }));
            newShowVirtualDeviceInfo = showVirtualDeviceInfo.map(device => ({
                ...device,
                x: device.x * relativeScaleChange,
                y: device.y * relativeScaleChange
            }));
        }
        
        this.setState({
          originalImageWidth: newDisplayImageWidth,
          originalImageHeight: newDisplayImageHeight,
          scaleWindow: newScaleWindow,
          lines: newLines,
          showVirtualDeviceInfo: newShowVirtualDeviceInfo,
          expectedWidth: containerWidth, 
          expectedHeight: containerHeight,
          centerWidth: [
              (containerWidth - newDisplayImageWidth) / 2,
              (containerHeight - newDisplayImageHeight) / 2,
              true 
          ]
        });
        
      }
    }, 250); 
  }

  getCurrentChannelRecommendation = () => {
    const { mappingInteriorGraph } = this.props;
    return {
      enabled: mappingInteriorGraph.channelRecommendationEnabled,
      advanced: mappingInteriorGraph.advancedChannelRecommendation,
      frequency: 2442,
      selectedChannels: {
        2442: mappingInteriorGraph.band24GHzChannels ?? [],
        5320: mappingInteriorGraph.band5GHz1Channels ?? [],
        5640: mappingInteriorGraph.band5GHz2Channels ?? [],
        8045: mappingInteriorGraph.band6GHzChannels ?? [],
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { mappingInteriorGraph, selectSite, floorPlanData, doGetFloorDetail, status, openModalTip, authToken, doGetAvaliableDeviceData, doGetVirtualDeviceData, graphId, activePage, popupModalConfirm, doActivePage, selectGraph, history, openModalAlert, doGetInteriorGraph, continueToChangeFloorPlan, endChangingFloorPlan, nextFloorPlanId, doGetFloorPlanProjectList } = this.props;
    const { centerWidth, redirectPage, expectedWidth, expectedHeight, originalImageWidth, originalImageHeight, scale, positionMap, selectedDevices, currentVirtualDevice, scaleWindow } = this.state;
    if (status === PRE_CHANGE_FLOOR_PLAN && graphId !== nextFloorPlanId) {
      if (this.checkGraphIsChange()) {
        popupModalConfirm('Confirm', 'icon-alert', 'Are you sure you want to leave this page and save the changes?', 300, () => {
          if (this.saveGraphData(true)) {
            this.setState({ shouldReload: false });
            continueToChangeFloorPlan();
          } else {
            endChangingFloorPlan();
          }
        }, () => continueToChangeFloorPlan());
        endChangingFloorPlan();
      } else {
        continueToChangeFloorPlan();
      }
    }

    if ((this.state.drawMode || (this.state.placingDeviceMode && this.state.selectedDevices !== null)) && (this.state.currentMaterial === "brick" || (prevState.currentMaterial !== this.state.currentMaterial) || (prevState.placingDeviceMode !== this.state.placingDeviceMode || prevState.selectedDevices !== this.state.selectedDevices))) {
      this.visualRef.current?.focus();
    }

    if (this.state.showZoomPercentage) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.setState({ showZoomPercentage: false });
      }, 3000);
    }

    if (prevState.selectedDevices !== selectedDevices && selectedDevices) {
      this.setState({
        placingDeviceMode: true,
        dragMode: false,
        eraseMode: false,
        drawMode: false,
        scaleMode: false,
      });
    }

    if (prevProps.graphId !== graphId) {
      doGetVirtualDeviceData(authToken, graphId);
      this.setState({ simulateData: null, showZoomPercentage: false });
    }

    if ((JSON.stringify(prevProps.mappingInteriorGraph) !== JSON.stringify(mappingInteriorGraph) && mappingInteriorGraph) || (prevProps.graphId !== graphId && graphId && mappingInteriorGraph)) {
      this.getInteriorImage(status === GET_VISUAL_GROUP_RSSI_INFO);
      this.setState({
        isSimulate: false,
        points: [],
        heatMap: null,
        color: 'rgba(244, 67, 54, 0.5)',
        currentMaterial: 'brick',
        lineLength: mappingInteriorGraph?.scale ?? 1,
        lineLengthYard: mappingInteriorGraph ? this.convertMeterToYard(mappingInteriorGraph.scale) : 1.0936,
        scaleLine: [{
          points: mappingInteriorGraph?.scaleLine.split(",").reduce((z, x) => z.concat(+x), []) ?? "1,1,2,2",
          stroke: "#b00f0c",
          strokeWidth: 3,
          x: 0,
          y: 0
        }],
        currentVirtualDevice: null,
        dragMode: true,
        eraseMode: false,
        drawMode: false,
        scaleMode: false,
        placingDeviceMode: false,
        scaleEnd: 0
      })
    }

    if (floorPlanData && prevProps.floorPlanData !== floorPlanData) {
      getVisualGroupRSSIAction(
          floorPlanData.rssiInfo,
          floorPlanData.orgId,
          floorPlanData.id,
          floorPlanData.interiorGraph,
          floorPlanData.wallInfo
      )
    }

      if (prevProps.status !== status) {
      switch (status) {
        case GET_HEATMAP_ALL_DATA_SUCCESS:
          this.convertBase64StringToPointArrayAll();
          break;
        case GET_HEATMAP_DATA_SUCCESS:
          this.convertBase64StringToPointArray();
          break;
        case GET_VISUAL_LIST_SUCCESS:
          this.setState({scaleMode: false, dragMode: true, drawMode: false, eraseMode: false})
          break;
        case SAVE_GRAPH_DATA_SUCCESS:
          openModalTip('Saved successfully.');
          this.saveUndoAndRedo();
          if (redirectPage !== null) {
            history.push(window.CONFIG.WEB_ROOT + '/' + redirectPage);
          } else {
            doActivePage('rf_map/floorplan');
            // doGetVisualData(authToken, selectFloorPlanProject);
            // doGetVisualDataId(authToken, selectFloorPlanProject);
            if (this.state.shouldReload === true) {
              doGetFloorDetail(authToken, graphId)
              doGetVirtualDeviceData(authToken, graphId)
            } else {
              this.setState({shouldReload: true});
            }
            this.setState({currentVirtualDevice: null});
          }
          break;
        case GET_VISUAL_GROUP_RSSI_INFO:
          this.reInitGraphData();
          break;
        case SAVE_VIRTUAL_DEVICE_INFO_SUCCESS:
          openModalTip('Saved successfully.');
          // doGetAvaliableDeviceData(authToken, 0, orgFilter);
          doGetVirtualDeviceData(authToken, graphId)
          this.setState({
            undoHistory: this.state.undoHistory.slice(0, -1),
            deviceHistory: this.state.deviceHistory.slice(0, -1)
          });
          break;
        case GET_VIRTUAL_DEVICE_DATA_SUCCESS:
          const remainingWithVirtualIndex = this.state.showVirtualDeviceInfo.filter(
            (e) => e?.virtualIndex !== undefined && e.virtualIndex !== currentVirtualDevice?.virtualIndex
          );

          const rssiInfo = this.props.deviceVirtualList.map(option => ({
            ...option,
            x: option.x * scaleWindow,
            y: option.y * scaleWindow
          }));

          const combinedList = [...rssiInfo, ...remainingWithVirtualIndex]
          this.setState({ showVirtualDeviceInfo: combinedList, currentVirtualDevice: null });
          break;
        case DELETE_VIRTUAL_DEVICE_SUCCESS:
          openModalTip('Delete successfully.');
          // doGetAvaliableDeviceData(authToken, 0, orgFilter);
          doGetVirtualDeviceData(authToken, graphId)
          this.setState({currentVirtualDevice: null});
          break;
        case GET_AVAILABLE_DEVICE_DATA_SUCCESS:
          const current = this.state.showVirtualDeviceInfo?.find((e => e.seq === this.state.currentVirtualDevice?.seq));
          if (current) {
            this.setState({currentVirtualDevice: current});
          } else {
            this.setState({currentVirtualDevice: null});
          }
          break;
        case SAVE_SCALE_DATA_SUCCESS:
        case SAVE_CHANNEL_RECOMMENDATION_SUCCESS:
          openModalTip('Saved successfully.');
          doGetInteriorGraph(authToken, graphId);
          break;
        case SAVE_SCALE_DATA_FAIL:
        case SAVE_CHANNEL_RECOMMENDATION_FAIL:
          openModalAlert("Something went wrong.");
          break
        case SAVE_VISUAL_MANAGER_DETAIL:
          doGetFloorPlanProjectList(authToken, selectSite);
          doGetFloorDetail(authToken, graphId);
          break;
        case DELETE_VISUAL_DATA_SUCCESS:
          doGetFloorPlanProjectList(authToken, selectSite);
          break;
        default:
          break;
      }
    }

    if (prevProps.selectGraph !== selectGraph) {
      localStorage.removeItem("undoHistory");
      localStorage.removeItem("redoHistory");
      localStorage.removeItem("deviceHistory");

      const newMap = new Map(positionMap);

      if (prevState.centerWidth && prevProps.selectGraph) {
        if (newMap.size === 1 && prevState.centerWidth[0] === 0 && prevState.centerWidth[1] === 0) {
          const prevCenterX = (prevState.expectedWidth - prevState.originalImageWidth) / 2;
          const prevCenterY = (prevState.expectedHeight - prevState.originalImageHeight) / 2;
          newMap.set(prevProps.selectGraph, [prevCenterX, prevCenterY, false, prevState.scale, this.currentZoomIndex]);
        } else {
          newMap.set(prevProps.selectGraph, [...prevState.centerWidth, prevState.scale, this.currentZoomIndex]);
        }
      }

      let positionValue

      const centerX = (expectedWidth - originalImageWidth) / 2;
      const centerY = (expectedHeight - originalImageHeight) / 2;

      if (!newMap.has(selectGraph)) {
        positionValue = [centerX, centerY, false, 1, 7];
        newMap.set(selectGraph, positionValue);
        this.setState({
          centerWidth: [centerX, centerY, true],
          scale: 1,
        });
        this.currentZoomIndex = 7;
      } else {
        positionValue = newMap.get(selectGraph);
        this.currentZoomIndex = positionValue[4];
        this.setState({
          centerWidth: [positionValue[0], positionValue[1], positionValue[2]],
          scale: positionValue[3],
        });
      }

      if (this.lineLayerRef.current) {
        this.lineLayerRef.current.position({ x: positionValue[0], y: positionValue[1] });
        this.lineLayerRef.current.scale({ x: positionValue[3], y: positionValue[3] });
        this.lineLayerRef.current.batchDraw();
      }

      this.setState({
        deviceHistory: [],
        redoHistory: [],
        undoHistory: [],
        positionMap: newMap,
      });
    }

    if (prevProps.selectSite !== selectSite) {
      orgFilter = selectSite;
      // this.bindDevice();
      doGetAvaliableDeviceData(authToken, 0, orgFilter);
      this.setState({ currentVirtualDevice: null });
    }

    if (prevState.showVirtualDeviceInfo !== this.state.showVirtualDeviceInfo) {
      this.displayDeviceCount();
    }

    if (prevState.centerWidth !== centerWidth && centerWidth[2]) {
      const centerX = (expectedWidth - originalImageWidth) / 2;
      const centerY = (expectedHeight - originalImageHeight) / 2;
      
      if (this.lineLayerRef.current) {
        this.lineLayerRef.current.position({ x: centerX, y: centerY });
        this.lineLayerRef.current.scale({ x: scale, y: scale });
        this.lineLayerRef.current.batchDraw();
      }
      
      this.setState({
        centerWidth: [centerWidth[0], centerWidth[1], false] // Set flag to false after applying
      });
    }

    // active page check
    // save/leave(do not save and leave)/cancel(stay in the same page)
    if (prevProps.activePage !== activePage && prevProps.activePage === "rf_map/floorplan") {
      if (this.checkGraphIsChange()) {
        popupModalConfirm('Confirm', 'icon-alert', 'Are you sure you want to leave this page and save the changes?', 300, () => {
          this.setState({ redirectPage: activePage });
          this.saveGraphData(true);
        }, () => { history.push(window.CONFIG.WEB_ROOT + '/' + activePage); }, false);
        doActivePage(prevProps.activePage)
      } else {
        history.push(window.CONFIG.WEB_ROOT + '/' + activePage);
      }
    }

    if (prevState.heatmapDataArrays !== this.state.heatmapDataArrays) {
      this.setState({
        arrayIds: this.state.heatmapDataArrays.map(array => array.graphId),
        originalImageWidthArray: this.state.heatmapDataArrays.map(array => array.width),
        originalImageHeightArray: this.state.heatmapDataArrays.map(array => array.height),
        scaleArray: this.state.heatmapDataArrays.map(array => array.scale)
      });
    }
  }



  displayMaterialItem = () => {
    let itemLst = [];

    const groupedByCluster = _.mapValues(_.groupBy(wallMaterial, (value) => value[3]), (group) =>
      _.fromPairs(_.map(_.sortBy(group, (material) => material[0]), (material, key) => [key, material]))
    );

    let elseElement = groupedByCluster['Other']
    delete groupedByCluster.Other;
    groupedByCluster.Other = elseElement;

    Object.entries(groupedByCluster).forEach(([key, groupValue]) => {
      let treeSelect = {
        key: key,
        type: 'group',
        label: key
      }
      // console.log(groupValue)
      let childrenArr = [];
      Object.entries(groupValue).forEach(([_, groupValue]) => {
        let obj = {
          label: groupValue[4],
          key: groupValue[4],
          icon: <span style={{ width: '15px', height: '5px', backgroundColor: wallMaterial[groupValue[4]][2], borderRadius: '5px' }}> </span>
        }
        childrenArr.push(obj);
      })
      treeSelect['children'] = childrenArr;
      itemLst.push(treeSelect);
    })
    return itemLst;
  }

  setMaterialItem = () => {
    let itemLst = [];
    let groupedByCluster = _.mapValues(_.groupBy(wallMaterial, (value) => value[3]), (group) =>
      _.fromPairs(_.map(_.sortBy(group, (material) => material[0]), (material, key) => [key, material]))
    );

    // Put the else material to the end
    let elseElement = groupedByCluster['Other']
    delete groupedByCluster.Other;
    groupedByCluster.Other = elseElement;
    

    Object.entries(groupedByCluster).forEach(([key, groupValue]) => {
      let treeSelect = {
        key: key,
        type: 'group',
        label: key
      }
      // console.log(groupValue)
      let childrenArr = [];
      Object.entries(groupValue).forEach(([_, groupValue]) => {
        let obj = {
          label: groupValue[4] + " ( " + groupValue[0] + "/" + groupValue[1] + " dB ) ",
          key: groupValue[4],
          icon: <span style={{ width: '15px', height: '5px', backgroundColor: wallMaterial[groupValue[4]][2], borderRadius: '5px' }}> </span>,
          id: `floor-plan-draw-${groupValue[4].replace(/\s+/g, '-')}`
        }
        childrenArr.push(obj);
      })
      treeSelect['children'] = childrenArr;
      itemLst.push(treeSelect);
    })
    return itemLst;
  }

  displayVirtualDeviceItem = () => {
    return [
      {
        label: <div id="floor-plan-wifi-place-devices-mi-10" style={{ lineHeight: '40px', justifyItems: 'center' }}>MI10</div>,
        key: "MI10",
        icon: <img src={mi10Img} alt="virtual_device.png" width={25} height={25} />
      },
      {
        label: <div id="floor-plan-wifi-place-devices-mi-11" style={{ lineHeight: '40px', justifyItems: 'center' }}>MI11</div>,
        key: "MI11",
        icon: <img src={mi11Img} alt="virtual_device.png" width={25} height={25} />
      },
      {
        label: <div id="floor-plan-wifi-place-devices-mi-12" style={{ lineHeight: '40px', justifyItems: 'center' }}>MI12</div>,
        key: "MI12",
        icon: <img src={mi12Img} alt="virtual_device.png" width={25} height={25} />
      },
      {
        label: <div id="floor-plan-wifi-place-devices-mi-13" style={{ lineHeight: '40px', justifyItems: 'center' }}>MI13</div>,
        key: "MI13",
        icon: <img src={mi13Img} alt="virtual_device.png" width={25} height={25} />
      },
      {
        label: <div id="floor-plan-wifi-place-devices-mi-14" style={{ lineHeight: '40px', justifyItems: 'center' }}>MI14</div>,
        key: "MI14",
        icon: <img src={mi14Img} alt="virtual_device.png" width={25} height={25} />
      },
    ];

  }

  displayWiFiCoverage = () => {
    const { frequency, isSimulate, resolutionLevel } = this.state;
    return [
      {
        label: <div style={{ width: '350px', height: '220px' }}>
          <p style={{ margin: '16px 0px 16px 16px', fontWeight: '500' }}>Wi-Fi Coverage</p>
          <hr />
          <p style={{ margin: '-5px 0px 5px 16px', fontFamily: 'Roboto', fontWeight: 300, fontSize: '12px' }}>Heatmap View</p>
          <button id="wifi-coverage-heatmap-view-off" className='drawing-tools-btn' style={{
            outline: 'none',
            borderRadius: '4px 0 0 4px',
            marginLeft: '16px',
            width: '162px',
            backgroundColor: !isSimulate ? '#0084dd' : '#fff',
            color: !isSimulate ? '#fff' : '#0084dd'
          }} onClick={() => {
            this.handleHeatmapToggle()
          }}>OFF
          </button>
          {/* <button disabled className='drawing-tools-btn' style={{ outline: 'none', width: '105px', backgroundColor: frequency === 0 ? '#0084dd' : '#fff', color: frequency === 0 ? '#fff' : '#0084dd' }} onClick={() => { this.handleHeatmapToggle() }}>Default</button> */}
          <button id="wifi-coverage-heatmap-view-on" className='drawing-tools-btn' style={{
            outline: 'none',
            borderRadius: '0 4px 4px 0',
            width: '162px',
            backgroundColor: isSimulate ? '#0084dd' : '#fff',
            color: isSimulate ? '#fff' : '#0084dd'
          }} onClick={() => {
            this.handleHeatmapToggle()
          }}>Heat Map
          </button>

          <p style={{ margin: '16px 0px 5px 16px', fontFamily: 'Roboto', fontWeight: 300, fontSize: '12px' }}>Wi-Fi Band</p>

          <Row style={{height: '40px'}}>
            <Col sm={6}>
              <button id="wifi-coverage-wifi-band-2.4ghz" disabled={!isSimulate} className='drawing-tools-btn' style={{
                outline: 'none',
                borderRadius: '4px 0 0 4px',
                width: '150px',
                backgroundColor: frequency === 2442 ? '#0084dd' : '#fff',
                color: frequency === 2442 ? '#fff' : '#0084dd'
              }} onClick={() => {
                this.setState({frequency: 2442, wifiCoverageDropdownOpen: false});
                this.getHeatmapData(2442, resolutionLevel);
              }}>2.4 GHz
              </button>
            </Col>

            <Col sm={6}>
              <button id="wifi-coverage-wifi-band-5ghz1" disabled={!isSimulate} className='drawing-tools-btn' style={{
                outline: 'none',
                borderRadius: '0 4px 4px 0',
                width: '150px',
                backgroundColor: frequency === 5320 ? '#0084dd' : '#fff',
                color: frequency === 5320 ? '#fff' : '#0084dd'
              }} onClick={() => {
                this.setState({frequency: 5320, wifiCoverageDropdownOpen: false});
                this.getHeatmapData(5320, resolutionLevel);
              }}> 5 GHz-1
              </button>
            </Col>
          </Row>

          <Row style={{height: '40px'}}>
            <Col sm={6}>
              <button id="wifi-coverage-wifi-band-5ghz2" disabled={!isSimulate} className='drawing-tools-btn' style={{
                outline: 'none',
                borderRadius: '4px 0 0 4px',
                width: '150px',
                backgroundColor: frequency === 5640 ? '#0084dd' : '#fff',
                color: frequency === 5640 ? '#fff' : '#0084dd'
              }} onClick={() => {
                this.setState({frequency: 5640, wifiCoverageDropdownOpen: false});
                this.getHeatmapData(5640, resolutionLevel);
              }}>5 GHz-2
              </button>
            </Col>

            <Col sm={6}>
              <button id="wifi-coverage-wifi-band-6ghz" disabled={!isSimulate} className='drawing-tools-btn' style={{
                outline: 'none',
                borderRadius: '0 4px 4px 0',
                width: '150px',
                backgroundColor: frequency === 8045 ? '#0084dd' : '#fff',
                color: frequency === 8045 ? '#fff' : '#0084dd'
              }} onClick={() => {
                this.setState({frequency: 8045, wifiCoverageDropdownOpen: false});
                this.getHeatmapData(8045, resolutionLevel);
              }}>6 GHz
              </button>
            </Col>
          </Row>

          {/* <p style={{ margin: '10px 0px 5px 16px', fontFamily: 'Roboto', fontWeight: 300, fontSize: '12px' }}>Resolution Level</p>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', borderRadius: '4px 0 0 4px', marginLeft: '16px', width: '45px', backgroundColor: resolutionLevel === 0 ? '#0084dd' : '#fff', color: resolutionLevel === 0 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 0, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 0) }}>0</button>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', width: '45px', backgroundColor: resolutionLevel === 1 ? '#0084dd' : '#fff', color: resolutionLevel === 1 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 1, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 1) }}>1</button>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', width: '45px', backgroundColor: resolutionLevel === 2 ? '#0084dd' : '#fff', color: resolutionLevel === 2 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 2, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 2) }}>2</button>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', width: '45px', backgroundColor: resolutionLevel === 3 ? '#0084dd' : '#fff', color: resolutionLevel === 3 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 3, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 3) }}>3</button>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', width: '45px', backgroundColor: resolutionLevel === 4 ? '#0084dd' : '#fff', color: resolutionLevel === 4 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 4, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 4) }}>4</button>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', width: '45px', backgroundColor: resolutionLevel === 5 ? '#0084dd' : '#fff', color: resolutionLevel === 5 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 5, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 5) }}>5</button>
          <button disabled={!isSimulate} className='drawing-tools-btn' style={{ outline: 'none', borderRadius: '0 4px 4px 0', width: '45px', backgroundColor: resolutionLevel === 6 ? '#0084dd' : '#fff', color: resolutionLevel === 6 ? '#fff' : '#0084dd' }} onClick={() => { this.setState({ resolutionLevel: 6, wifiCoverageDropdownOpen: false }); this.getHeatmapData(frequency, 6) }}>6</button> */}
        </div>,
        key: "wifi",
      }
    ];
  }

  displayDeviceCount = () => {
    const { showVirtualDeviceInfo } = this.state;
    const deviceCount = showVirtualDeviceInfo?.length || 0;
    this.setState({numberDevices: deviceCount});
  }

  handleSelectedDevice = (modelName) => {

    this.setState({
      selectedDevices: modelName,
    });

  }

  setCursorToDeviceIcon = () => {
    const {selectedDevices} = this.state;

    if (!selectedDevices) {
      return 'auto';
    }

    let iconUrl = '';


    switch (selectedDevices.key) {
      case 'MI10': iconUrl = mi10Cursor; break;
      case 'MI11': iconUrl = mi11Cursor; break;
      case 'MI12': iconUrl = mi12Cursor; break;
      case 'MI13': iconUrl = mi13Cursor; break;
      case 'MI14': iconUrl = mi14Cursor; break;
      default: return 'auto';
    }

    return `url(${iconUrl}) 16 16, pointer`;

  }

  handleRightClick = (e) => {
    e.evt.preventDefault();
    const isRightClick = e.evt.button === 2;

    if(this.state.placingDeviceMode && isRightClick) {
      this.setState({
        placingDeviceMode: false,
        currentVirtualDevice: null,
        dragMode: true
      });
    }
  }


  render() {
    const { mappingInteriorGraph, heatmapData, popLoading, deviceList, dispathVisualMangerDetail, openModal, selectGraph, isLoadingFloorData } = this.props;
    const { showVirtualDeviceInfo, drawMode, eraseMode, scaleMode, dragMode, scale, isSimulate, currentVirtualDevice, originalImageWidth, originalImageHeight, expectedWidth, expectedHeight,  placingDeviceMode } = this.state;
    // const width = window.innerWidth > 1600 ? 700 * scale : 700 * scale;
    // const height = window.innerWidth > 1600 ? 500 * scale : 500 * scale;
    const modeInfo = modeInfoData[eraseMode ? "erase" : drawMode ? "draw" : scaleMode ? "scale" : placingDeviceMode ? "placingDevice" : ""];

    let renderContent;
    if (!mappingInteriorGraph && !isLoadingFloorData) {
      renderContent = (
        <div className='area-visual-widget icon-interior-design-demo'>
          <div className='area-devices'>This group does not bind any interior graph.</div>
        </div>
      );

    }
    else {
      if (mappingInteriorGraph && showVirtualDeviceInfo && deviceList && !isLoadingFloorData) {
        renderContent = (
          <>

            {/* <button className='drawing-tools-btn' onClick={() => this.setState({ lines: [] })} disabled={isSimulate}>
                Clear
              </button> */}

            {/* <button onClick={()=>{
                // TODO if it zooms, the layyer will be cut
                console.log(this.lineLayerRef)
                this.lineLayerRef.current.scale({ x: 1, y: 1 });
                this.setState({scale: 1});
                const result = this.lineLayerRef.current.toDataURL({width: 600, height: 500, pixelRatio: 3 });
                console.log(result)
              }}>Export</button> */}


            <div className='area-visual-widget icon-interior-design-demo' ref={this.visualRef} tabIndex="0" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp}>
              <Loading loading={popLoading} />
              {this.state.showZoomPercentage && (
                <div className='zoom-percentage'>
                  {this.state.zoomPercentage}%
                </div>
              )}
              {scaleMode ? <div className='scale-container'>
                <Row>
                  <Col xs={7}>
                    <TextField
                        id="floor-plan-scale-length-input"
                        label="Length"
                        value={
                          this.state.unit === "meter"
                              ? this.state.lineLength
                              : this.state.lineLengthYard
                        }
                        size='small'
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          this.state.unit === "meter"
                              ? this.setStateLengthMeter(inputValue)
                              : this.setStateLengthYard(inputValue)
                        }}
                        onBlur={(e) => {
                          const inputValue = e.target.value;
                          let isValid = Number(inputValue) > 0 ;
                          let errorMessage = "";

                          if (isValid) {
                            if (this.state.unit === "meter" && inputValue >= 1000) {
                              isValid = false;
                              errorMessage = (
                                <>
                                  Must be less than
                                  <br />
                                  1000 meters
                                </>
                              );
                            } else if (this.state.unit === "yard" && inputValue >= 1093.61) {
                              isValid = false;
                              errorMessage = (
                                <>
                                  Must be less than
                                  <br />
                                  1093.61 yards
                                </>
                              );
                            }
                          } else {
                            errorMessage = "Please enter a valid number";
                          }
                    
                          this.setState({
                            inputError: !isValid,
                            helperText: !isValid ? errorMessage : ""
                          });
                        }}
                        className="scale-input"
                        error={this.state.inputError}
                        helperText={this.state.helperText || ""}
                    />
                  </Col>
                  <Col xs={5}>
                    <FormControl
                        size="small"
                        className={"scale-select"}
                    >
                      <InputLabel id="unit-label">Unit</InputLabel>
                      <Select
                          id="floor-plan-scale-unit"
                          labelId="unit-label"
                          value={this.state.unit}
                          onChange={this.handleUnitChange}
                          label="Unit"
                          variant='outlined'>
                        <MenuItem value="meter">Meter</MenuItem>
                        <MenuItem value="yard">Yard</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{span: 2, offset: 5}}>
                    <Button id="floor-plan-scale-reset-btn" type="button" variant="primary" className='button button-reset' onClick={this.resetScale}>
                      Reset
                    </Button>
                  </Col>
                  <Col xs={3}>
                    <Button id="floor-plan-scale-redraw-btn" type="button" variant="primary" className='button btn-redraw' onClick={this.redrawScale}>
                      Redraw
                    </Button>
                  </Col>
                  <Col xs={2}>
                    <Button id="floor-plan-scale-save-btn" type="submit" variant="primary" className='button btn-save' onClick={this.saveScale}>
                      Save
                    </Button>
                  </Col>
                </Row>

                <br/><br/></div> : ''}
              <Stage
                width={window.innerWidth}
                height={Math.max(window.innerHeight - 210, originalImageHeight * scale)}
                // onMouseDown={drawMode || eraseMode || scaleMode ? this.handleMouseDown : null}
                // onMouseMove={drawMode || eraseMode || scaleMode ? this.handleMouseMove : null}
                // onMouseUp={drawMode || eraseMode ? this.handleMouseUp : null}
                // onDblclick={drawMode || scaleMode ? this.handleDoubleClick : null}
                // scale={{ x: scale, y: scale }} // Apply the scale to the Stage component
                ref={this.stageRef}
                style={{
                  // backgroundImage: this.state.backgroundImg,
                  cursor: eraseMode ? 'auto' : drawMode || scaleMode ? 'crosshair' : placingDeviceMode ? this.setCursorToDeviceIcon() : 'grab',
                  // backgroundSize: 'cover',
                  // backgroundPosition: 'center',
                  // width: width + 'px',
                  // height: height + 'px',
                  // border: 'dashed 1px black',
                  top: '-10px',
                  right: '50px',
                  overflow: 'hidden',

                }}
              >
                <Layer ref={this.lineLayerRef}
                  onMouseDown={drawMode || eraseMode || scaleMode || placingDeviceMode ? this.handleMouseDown : null}
                  onMouseMove={drawMode || eraseMode || scaleMode || placingDeviceMode ? this.handleMouseMove : null}
                  onDblclick={drawMode || scaleMode ? this.handleDoubleClick : null}
                  onWheel={(e) => {
                    if (!e || !e.evt) return;
                    e.evt.preventDefault();
                    const delta = e.evt.deltaY;
                    
                    if (delta > 0) {
                      this.handleZoomIn();
                    } else {
                      this.handleZoomOut();
                    }
                  }}
                  scale={{ x: scale, y: scale }}
                  draggable={!drawMode && !placingDeviceMode}
                  onDragEnd={(e) => { this.setState({ centerWidth: [e.target._lastPos.x, e.target._lastPos.y, false] }) }}
                  x={(expectedWidth - originalImageWidth) / 2}
                  y={(expectedHeight - originalImageHeight) / 2}
                  onContextmenu={this.handleRightClick}
                >

                  <Image
                    image={this.state.backgroundImg}
                    x={0}
                    y={0}
                    width={originalImageWidth}
                    height={originalImageHeight}

                  />
                  {!scaleMode ? this.state.lines?.map((line, index) => (
                    <Line
                      key={index}
                      x={line.x}
                      y={line.y}
                      points={line.points}
                      stroke={line.stroke}
                      strokeWidth={line.strokeWidth}
                      onMouseDown={() => eraseMode ? this.handleLineClick(line) : null}
                    // draggable={!drawMode && !eraseMode}
                    // onDragEnd={(e) => this.handleLineDragEnd(index, e)}

                    />
                  )) : null}
                  <Transformer ref={this.transformerRef} />

                    { /* Heatmap Image */}
                    {isSimulate ? <>
                      <Image
                        image={this.state.heatMap}
                        width={originalImageWidth}
                        height={originalImageHeight}
                      />
                    </> : null}

                  {/* Place the AP Icon */}

                  {this.renderDevices(showVirtualDeviceInfo)}


                  { /* Scale Line */}

                  {scaleMode ?
                    this.state.scaleLine.map((line, index) => (
                      <Line
                        key={index}
                        x={line.x}
                        y={line.y}
                        points={line.points}
                        stroke={line.stroke}
                        strokeWidth={line.strokeWidth}
                        onMouseDown={() => eraseMode ? this.handleLineClick(line) : null}
                      // draggable={!drawMode && !eraseMode}
                      // onDragEnd={(e) => this.handleLineDragEnd(index, e)}

                      />
                    ))
                    : null}


                </Layer>


              </Stage>

              {isSimulate && this.state.points.length > 0 ? <RssiHeatMap data={this.state.points} width={heatmapData?.width}
                height={heatmapData?.height} handleHeatmapImage={this.handleHeatmapImage} shouldDisplay={true}/> : null}

              {this.state.heatmapDataArrays.length > 0 && this.state.isExporting && 
                this.state.heatmapDataArrays.map((array, index) => (
                  <RssiHeatMap 
                    graphId={this.props.heatmapAllData[index]?.graphId}
                    data={array.points} 
                    width={this.props.heatmapAllData[index]?.width}
                    height={this.props.heatmapAllData[index]?.height} 
                    handleHeatmapImage={this.handlePDFHeatmapImage} 
                    shouldDisplay={false}
                  />
                ))
              }
            </div>

            {/* Virtual Device Setting */}

            {currentVirtualDevice !== null ?
              <div className='virtual-device-info'>{currentVirtualDevice.name} <span className='icon-btn-close-black-n' onClick={() => this.closeVirtualDeviceForm()} /><hr style={{ margin: '10px 0px' }} />
                <span className='area-icon-delete' onClick={() => this.handleDeleteVirtualDevice(currentVirtualDevice)}><span className='icon-btn-delete-n'></span>Delete</span><hr style={{ margin: '10px 0px' }} />
                <VirtualDeviceForm data={currentVirtualDevice} scaleWindow={this.state.scaleWindow} graphId={mappingInteriorGraph.id} closeVirtualModal={this.closeVirtualDeviceForm} />
              </div>
              : ''
            }


          </>
        )
      }
      else {
        renderContent = (<Loading loading={true}></Loading>);
      }
    }

    return (
      <>
        <div className='area-blueprint'>

          <div className='area-adjust'>
            <div className='area-filter'>
              <div style={selectGraph ? {display: 'block'} : {display: 'none'}}>
                <SelectQuickFloorPlan/>
                <span id="floor-plan-toolbar-settings-btn" className='icon-settings' title='Settings'
                      onClick={() => openModal('visualManagerSetting', 'setting', null)}></span>
              </div>
            </div>

            <div className='area-setting-visual'>
              <span id="floor-plan-toolbar-undo-btn" className='icon-btn-undo-n' onClick={this.handleUndo} title='Undo'/>
              <span id="floor-plan-toolbar-redo-btn" className='icon-btn-redo-n' onClick={this.handleRedo} title='Redo'></span>
              <span id="floor-plan-toolbar-zoom-out-btn" className='icon-btn-zoom-out-n' onClick={this.handleZoomOut} title='Zoom Out'/>
              <span id="floor-plan-toolbar-zoom-in-btn" className='icon-btn-zoom-in-n' onClick={this.handleZoomIn} title='Zoom In'/>
              <span id="floor-plan-toolbar-center-btn" className='icon-btn-target-center' title='Center' onClick={() => {
                const centerX = (expectedWidth - originalImageWidth) / 2;
                const centerY = (expectedHeight - originalImageHeight) / 2;
                this.currentZoomIndex = 7; // Reset to 100%
                this.setState({
                  centerWidth: [centerX, centerY, true],
                  scale: 1,
                  zoomPercentage: 100,
                  showZoomPercentage: true
                });
                if (this.state.drawMode || this.state.placingDeviceMode) {
                  this.visualRef.current?.focus();
                }
              }}/>
            </div>

            {<this.renderChannelRecommendation/>}

            {/* Wi-Fi Coverage Dropdown */}
            <div className='area-wifi-coverage'>
              <Dropdown trigger="click" overlayClassName='custom-dropdown-menu' autoAdjustOverflow={false}
                        menu={{items: this.displayWiFiCoverage()}} placement="bottom"
                        onOpenChange={(e) => this.setState({wifiCoverageDropdownOpen: e})}>
                <Button id="floor-plan-toolbar-wifi-coverage-btn" type="text" style={{marginRight: "10px"}} title='Wi-Fi Coverage' icon={<span
                    className={this.state.wifiCoverageDropdownOpen ? 'icon-btn-wifi-coverage-p' : 'icon-btn-wifi-coverage-n'}></span>}></Button>
              </Dropdown>
              {isSimulate ? <span id="floor-plan-toolbar-wifi-coverage-toggle-btn-on" className='off-wifi-coverage' title='Wi-Fi Coverage Toggle' onClick={() => this.handleHeatmapToggle()}><span
                      className='icon-btn-password-hide-n'></span>OFF</span> :
                  <span id="floor-plan-toolbar-wifi-coverage-toggle-btn-off" className='on-wifi-coverage' title='Wi-Fi Coverage Toggle' onClick={() => this.handleHeatmapToggle()}><span
                      className='icon-btn-password-show-n'></span>ON</span>}

              <div className='area-tooltip d-flex align-items-center justify-content-center'>
                {eraseMode || drawMode || scaleMode || placingDeviceMode ? <span style={{
                  fontSize: '10px',
                  backgroundColor: '#e5e5e5',
                  padding: '5px',
                  width: eraseMode ? '140px' : drawMode ? '500px' : '280px',
                  height: '22px',
                  borderRadius: '5px'
                }}> {modeInfo} </span> : null}
              </div>
            </div>

            <div className='area-modify-visual'>
              <Button
                  id="floor-plan-toolbar-import-btn"
                  className='area-btns'
                      onClick={() => openModal("visualMangerImportPDF", "add-multi-floor", null, () => dispathVisualMangerDetail(null))}>
                <span className='icon-btn-import' title='Import'></span>
              </Button>

              <PdfGenerator heatmapImg={this.state.pdfHeatMap}
                            originalImageWidth={this.state.originalImageWidth}
                            originalImageHeight={this.state.originalImageHeight}
                            lines={this.state.lines}
                            showVirtualDeviceInfo={this.state.showVirtualDeviceInfo}
                            handlePDFHeatmap={this.handlePDFHeatmap.bind(this)}
                            getImage={this.getImage.bind(this)}
                            setIsExporting={(value) => this.setState({ isExporting: value })}
                            arrayIds={this.state.arrayIds}
                            originalImageWidthArray={this.state.originalImageWidthArray}
                            originalImageHeightArray={this.state.originalImageHeightArray}
                            scaleArray={this.state.scaleArray}/>

              <span id="floor-plan-toolbar-erase-btn" className='icon-draw-tool' disabled={isSimulate} title='Erase' onClick={() => this.setState({
                eraseMode: true,
                drawMode: false,
                dragMode: false,
                scaleMode: false,
                placingDeviceMode: false
              })}><span className={eraseMode ? 'icon-btn-erase-p' : 'icon-btn-erase-n'}/></span>
              <span id="floor-plan-toolbar-move-btn" className='icon-draw-tool' disabled={isSimulate} title='Move' onClick={() => this.setState({
                drawMode: false,
                eraseMode: false,
                dragMode: true,
                scaleMode: false,
                placingDeviceMode: false
              })}><span className={dragMode ? 'icon-btn-drag-p' : 'icon-btn-drag-n'}/></span>


              <Dropdown trigger="click" onClick={() => this.setState({
                eraseMode: false,
                drawMode: true,
                dragMode: false,
                scaleMode: false,
                placingDeviceMode: false
              })} overlayClassName='custom-dropdown-menu-material' overlayStyle={{cursor: 'pointer'}}
                        autoAdjustOverflow={false} menu={{
                items: this.setMaterialItem(),
                selectable: true,
                onClick: (e) => this.handleMaterialChange(e)
              }} placement="bottom" onOpenChange={(e) => {
                this.setState({brickDropdownOpen: e});
              }}>
                <Button id="floor-plan-toolbar-draw-btn" type="text" style={{top: '-3px', right: '4px'}} title='Draw' icon={<><span
                    className={this.state.brickDropdownOpen || drawMode ? 'icon-btn-brick-p' : 'icon-btn-brick-n'}></span><span
                    className='icon-arrow-down'></span></>}>
                </Button>
              </Dropdown>
              <span id="floor-plan-toolbar-scale-btn" className='icon-draw-tool' disabled={isSimulate} title='Scale' onClick={this.enableScaleMode}><span className={scaleMode ? 'icon-btn-scale-p' : 'icon-btn-scale-n'}/></span>
              <span id="floor-plan-toolbar-save-btn" className='btn-save-visual' onClick={() => this.saveGraphData(false)}>Save</span>

              <Dropdown
                  id="floor-plan-wifi-place-devices-type"
                  overlayStyle={{
                    backgroundColor: '#fff',
                    width: '350px',
                  }}
                  overlayClassName='add-device'
                  menu={{items: this.displayVirtualDeviceItem(), onClick: this.handleSelectedDevice}}
                  placement="bottomRight"
                  dropdownRender={(menu) => (
                      <div style={{
                        boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.4)',
                        border: 'solid 1px rgba(229, 229, 229, 0.4)',
                        borderRadius: '10px'
                      }}>
                        <p style={{margin: '16px 0px 16px 16px', fontWeight: '500'}}>Place Devices</p>
                        <hr/>
                        <p style={{
                          margin: '-5px 0px 0px 16px',
                          fontFamily: 'Roboto',
                          fontWeight: 300,
                          fontSize: '12px'
                        }}>Device Type</p>
                        <select style={{marginLeft: '13px', width: '320px', border: 'none', outline: 'none'}}>
                          <option value="Wi-Fi">Wi-Fi</option>
                        </select>
                        {menu}
                        <br/>
                      </div>
                  )}
                  trigger="click"
              >
                <Button id="floor-plan-toolbar-place-devices-btn" style={{position: 'relative', border: 'none'}}>
                  <span className='area-add-icon'><span className='icon-btn-add-n'></span> Place devices</span>
                </Button>
              </Dropdown>
            </div>
          </div>

          <div className='line' style={selectGraph ? {display: 'block', width: '98%', marginRight: 'auto', marginLeft: 'auto'} : {display: 'none'}}></div>

          <div>
            <Button style={{position: 'absolute', right: '150px', zIndex: 500, pointerEvents: 'none', marginRight: '20px'}}>
              <Space>
                Devices: {this.state.numberDevices}
              </Space>
            </Button>

            {/* Material Dropdown*/}
            <Dropdown trigger="click" overlayClassName='custom-dropdown-menu' autoAdjustOverflow={false}
                      menu={{items: this.displayMaterialItem()}} placement="bottomRight">
              <Button style={{position: 'absolute', right: '50px', zIndex: 500}}>
                <Space>
                  Material
                  <DownOutlined/>
                </Space>
              </Button>
            </Dropdown>

          </div>

          {renderContent}
        </div>
      </>
    );
  }

  renderChannelRecommendation = () => {
    const { channelRecommendation, channelRecommendationShow } = this.state;
    const enabled = channelRecommendation.enabled;
    const advanced = channelRecommendation.advanced;
    const selectedFrequency = channelRecommendation.frequency
    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            rootClose
            onToggle={(e) => this.setState({ channelRecommendationShow: e })}
            show={channelRecommendationShow}
            overlay={
              <Popover id='channel-recommendation'
                       className={'popover-custom'}
              >
                <Popover.Content>
                  <div style={{width: 'auto', height: 'auto'}}>
                    <p style={{margin: '16px 0px 16px 26px', fontWeight: '500'}}>Channel Recommendation</p>
                    <hr/>

                    <p style={{
                      margin: '-5px 0px 5px 26px',
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: '12px'
                    }}>Recommendation View</p>
                    <button id="channel-recommendation-off" className='drawing-tools-btn' style={{
                      outline: 'none',
                      borderRadius: '4px 0 0 4px',
                      marginLeft: '26px',
                      width: '164px',
                      backgroundColor: !enabled ? '#0084dd' : '#fff',
                      color: !enabled ? '#fff' : '#0084dd'
                    }} onClick={() => {
                      this.handleRecommendationViewToggle()
                    }}>OFF
                    </button>
                    <button id="channel-recommendation-on" className='drawing-tools-btn' style={{
                      outline: 'none',
                      borderRadius: '0 4px 4px 0',
                      width: '164px',
                      backgroundColor: enabled ? '#0084dd' : '#fff',
                      color: enabled ? '#fff' : '#0084dd'
                    }} onClick={() => {
                      this.handleRecommendationViewToggle()
                    }}>Recommend Channels
                    </button>

                    {enabled && (
                      <>
                    <p style={{
                      margin: '16px 0px 5px 26px',
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: '12px'
                    }}>Advanced recommendation</p>
                    <button
                      id="channel-recommendation-advanced-off"
                      className='drawing-tools-btn' style={{
                      outline: 'none',
                      borderRadius: '4px 0 0 4px',
                      marginLeft: '26px',
                      width: '164px',
                      backgroundColor: !advanced ? '#0084dd' : '#fff',
                      color: !advanced ? '#fff' : '#0084dd'
                    }} onClick={() => {
                      this.handleAdvancedToggle()
                    }}>OFF
                    </button>
                    <button
                        id="channel-recommendation-advanced-on"
                        className='drawing-tools-btn' style={{
                      outline: 'none',
                      borderRadius: '0 4px 4px 0',
                      width: '164px',
                      backgroundColor: advanced ? '#0084dd' : '#fff',
                      color: advanced ? '#fff' : '#0084dd'
                    }} onClick={() => {
                      this.handleAdvancedToggle()
                    }}>ON
                    </button>
                    { advanced && (<>
                    <p style={{
                      margin: '16px 0px 5px 26px',
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: '12px'
                    }}>Wi-Fi Band</p>
                    <Row style={{height: '40px'}}>
                      <Col sm={6} style={{paddingLeft: '26px'}}>
                        <button id="channel-recommendation-wifi-band-2.4ghz" className='drawing-tools-btn' style={{
                          outline: 'none',
                          borderRadius: '4px 0 0 4px',
                          width: '150px',
                          backgroundColor: selectedFrequency === 2442 ? '#0084dd' : '#fff',
                          color: selectedFrequency === 2442 ? '#fff' : '#0084dd'
                        }} onClick={() => this.onChangeWifiBandChannelRecommendation(2442)}
                        >2.4 GHz
                        </button>
                      </Col>

                      <Col sm={6} style={{paddingRight: '26px'}}>
                        <button id="channel-recommendation-wifi-band-5ghz" className='drawing-tools-btn' style={{
                          outline: 'none',
                          borderRadius: '0 4px 4px 0',
                          width: '150px',
                          backgroundColor: selectedFrequency === 5320 ? '#0084dd' : '#fff',
                          color: selectedFrequency === 5320 ? '#fff' : '#0084dd'
                        }} onClick={() => this.onChangeWifiBandChannelRecommendation(5320)}
                        >5 GHz-1
                        </button>
                      </Col>
                    </Row>

                    <Row style={{height: '40px'}}>
                      <Col sm={6} style={{paddingLeft: '26px'}}>
                        <button id="channel-recommendation-wifi-band-5ghz2" className='drawing-tools-btn' style={{
                          outline: 'none',
                          borderRadius: '4px 0 0 4px',
                          width: '150px',
                          backgroundColor: selectedFrequency === 5640 ? '#0084dd' : '#fff',
                          color: selectedFrequency === 5640 ? '#fff' : '#0084dd'
                        }} onClick={() => this.onChangeWifiBandChannelRecommendation(5640)}
                        >5 GHz-2
                        </button>
                      </Col>

                      <Col sm={6} style={{paddingRight: '26px'}}>
                        <button id="channel-recommendation-wifi-band-6ghz" className='drawing-tools-btn' style={{
                          outline: 'none',
                          borderRadius: '0 4px 4px 0',
                          width: '150px',
                          backgroundColor: selectedFrequency === 8045 ? '#0084dd' : '#fff',
                          color: selectedFrequency === 8045 ? '#fff' : '#0084dd'
                        }} onClick={() => this.onChangeWifiBandChannelRecommendation(8045)}
                        >6 GHz
                        </button>
                      </Col>
                    </Row>

                    <p style={{
                      margin: '8px 0px 5px 26px',
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: '12px'
                    }}>Auto Channel Selector</p>
                    <div onClick={(e) => e.stopPropagation()}>

                    <Autocomplete
                        id="channel-recommendation-auto-channel-selector"
                        disablePortal
                        multiple
                        filterSelectedOptions
                        disableCloseOnSelect
                        options={this.autoChannelsOptions[selectedFrequency]}
                        getOptionLabel={(option) => String(option)}
                        value={channelRecommendation.selectedChannels[selectedFrequency]}
                        onChange={this.onChangeAutoChannelSelector}
                        className={"autocomplete-channels"}
                        renderTags={(value, getTagProps) => (
                            <div style={{
                                maxHeight: '110px',
                                overflowY: 'auto',
                                display: 'flex',
                                flexWrap: 'wrap'
                            }}>
                                {value.map((option, index) => (
                                    <Chip key={index} label={option} {...getTagProps({ index })} />
                                ))}
                            </div>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                error={channelRecommendation.selectedChannels[selectedFrequency].length < 2}
                                helperText={channelRecommendation.selectedChannels[selectedFrequency].length < 2 ? "Please select at least 2 channels" : ""}
                                placeholder={channelRecommendation.selectedChannels[selectedFrequency].length === 0 ? 'Select channels' : ''}
                                sx={{
                                    '.MuiInputBase-root': {
                                        maxHeight: '180px',
                                        overflow: 'hidden',
                                        alignItems: 'flex-start',
                                    },
                                }}
                            />
                        )}
                        style={{margin: 'auto 26px 10px 26px', width: '324px'}}
                    />
                    </div>

                      <p style={{
                      margin: '8px 26px 5px 26px',
                      fontFamily: 'Roboto',
                      fontWeight: 300,
                      fontSize: '11px'
                    }}>Select the desired Wi-Fi channels (e.g., {this.defaultChannelsForRecommendation[selectedFrequency].join(', ')}) to receive the best access point (AP) channel recommendation.</p>
                    </>)}
                      </>
                    )}
                    <Row>
                      <Col xs={{span: 2, offset: 7}} className={"col"}>
                        <Button id="channel-recommendation-cancel" type="button" variant="primary" className='button button-cancel'
                                onClick={() => {this.cancelChannelRecommendationChange()}}>
                          Cancel
                        </Button>
                      </Col>
                      <Col xs={{span: 2}} className={"col"}>
                        <Button id="channel-recommendation-save" type="submit" variant="primary" className='button btn-save' onClick={this.saveChannelRecommendation}>
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Popover.Content>
              </Popover>
            }
        >
          <Button type="text" title='Channel Recommendation' icon={<span
              className={this.state.channelRecommendationShow ? 'icon-channels-recommendation-blue' : 'icon-channels-recommendation'}></span>}
                  onClick={() => {
                    this.setState({
                      channelRecommendationShow: !channelRecommendationShow,
                      frequency: channelRecommendation.frequency,
                    });

                    if (this.state.drawMode || this.state.placingDeviceMode) {
                      this.visualRef.current?.focus();
                    }
                  }
          }
                  id="floor-plan-toolbar-channel-recommendation-btn"
          ></Button>
        </OverlayTrigger>
    );
  };

  handleRecommendationViewToggle = () => {
    const {channelRecommendation, isSimulate, resolutionLevel} = this.state;
    channelRecommendation.enabled = !channelRecommendation.enabled;
    this.setState({channelRecommendation: channelRecommendation});
    if (isSimulate) {
      this.getHeatmapData(channelRecommendation.frequency, resolutionLevel);
    }
  }

  handleAdvancedToggle = () => {
    const {channelRecommendation, isSimulate, frequency, resolutionLevel} = this.state;
    channelRecommendation.advanced = !channelRecommendation.advanced;
    this.setState({channelRecommendation: channelRecommendation});
    if (isSimulate) {
      this.getHeatmapData(frequency, resolutionLevel);
    }
  }

  onChangeWifiBandChannelRecommendation = (value) => {
    const {channelRecommendation, isSimulate, resolutionLevel} = this.state;
    if (value === channelRecommendation.frequency) {
      return
    }
    channelRecommendation.frequency = value
    this.setState({
      channelRecommendation: channelRecommendation,
      frequency: value,
    });
    if (isSimulate) {
      this.getHeatmapData(value, resolutionLevel);
    }
  }

  onChangeAutoChannelSelector = (event, newValue) => {
    const {channelRecommendation, isSimulate, resolutionLevel} = this.state;
    const selectedFrequency = channelRecommendation.frequency
    channelRecommendation.selectedChannels[selectedFrequency] = newValue
    this.setState({
      channelRecommendation: channelRecommendation,
    })
    if (isSimulate && newValue.length >= 2) {
      this.getHeatmapData(selectedFrequency, resolutionLevel);
    }
  }

  cancelChannelRecommendationChange = () => {
    const {popupModalConfirm} = this.props;
    const channelRecommendation = this.getCurrentChannelRecommendation()
    if (this.isChannelRecommendationNotChanged()) {
      this.setState({
        channelRecommendationShow: false,
        channelRecommendation: channelRecommendation,
      });
    } else {
      this.setState({channelRecommendationShow: false});
      popupModalConfirm('Leave Channel Recommendation Config', 'icon-alert', 'Changes you made may not be saved', 300, () => {
        this.setState({
          channelRecommendation: channelRecommendation,
        });
      }, () => this.setState({channelRecommendationShow: true}), false);
    }
  }

  saveChannelRecommendation = () => {
    const {popupModalConfirm, accountRole, roleTableAuth, openModalAlert, authToken, mappingInteriorGraph, doSaveChannelRecommendation} = this.props;
    const {channelRecommendation} = this.state;
    const selectedChannels = channelRecommendation.selectedChannels;
    this.setState({channelRecommendationShow: false});
    if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
      if (channelRecommendation.advanced) {
        for (const frequency in selectedChannels) {
          if (selectedChannels[frequency].length < 2) {
            openModalAlert('Please select at least 2 channels in Wi-Fi band ' + (frequency === '2442' ? '2.4GHz' : frequency === '5320' ? '5GHz-1' : frequency === '5640' ? '5GHz-2' : '6GHz'),
                'Channel Recommendation', () => this.setState({ channelRecommendationShow: true }));
            return;
          }
        }
      }

      const channelRecommendationConfig = this.getChannelRecommendationConfig();
      popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save the change?', 300, () => {
        doSaveChannelRecommendation(authToken, mappingInteriorGraph.id, channelRecommendationConfig);
      }, () => this.setState({channelRecommendationShow: true}), false);
    } else {
      openModalAlert("Sorry you don't have permission to change config.");
    }
  }

  getChannelRecommendationConfig = () => {
    const {channelRecommendation} = this.state;
    const selectedChannels = channelRecommendation.selectedChannels;
    const defaultChannels = this.defaultChannelsForRecommendation;
    return {
      'channelRecommendationEnabled': channelRecommendation.enabled,
      'advancedChannelRecommendation': channelRecommendation.advanced,
      'band24GHzChannels': channelRecommendation.advanced ? selectedChannels[2442] : defaultChannels[2442],
      'band5GHz1Channels': channelRecommendation.advanced ? selectedChannels[5320] : defaultChannels[5320],
      'band5GHz2Channels': channelRecommendation.advanced ? selectedChannels[5640] : defaultChannels[5640],
      'band6GHzChannels': channelRecommendation.advanced ? selectedChannels[8045] : defaultChannels[8045],
    }
  }

  enableScaleMode = () => {
    this.setState({
      drawMode: false,
      eraseMode: false,
      scaleMode: true,
      dragMode: false,
      placingDeviceMode: false
    })
  }

  resetScale = () => {
    this.setState({
      scaleEnd: 0,
      isDrawing: false,
      unit: 'meter',
      lineLength: 1,
      lineLengthYard: 1.0936,
      scaleLine: [{
        "points": [
          1,
          1,
          2,
          2
        ],
        "stroke": "#b00f0c",
        "strokeWidth": 3,
        "x": 0,
        "y": 0
      }],
    });
  }

  redrawScale = () => {
    const {mappingInteriorGraph} = this.props;
    const previousScale = {
      lineLength: mappingInteriorGraph.scale,
      lineLengthYard: this.convertMeterToYard(mappingInteriorGraph.scale),
      scaleLine: [{
        points: mappingInteriorGraph.scaleLine.split(",").reduce((z, x) => z.concat(+x), []),
        stroke: "#b00f0c",
        strokeWidth: 3,
        x: 0,
        y: 0
      }],
    };
    this.setState(previousScale)
    this.setState({
      scaleEnd: 0,
      isDrawing: false,
    })
  }

  saveScale = () => {
    const {popupModalConfirm, accountRole, roleTableAuth, openModalAlert, authToken, mappingInteriorGraph, doSaveScaleData} = this.props;
    if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
      const isValidInteger = Number(this.state.lineLength) > 0 && Number(this.state.lineLength) < 1000;
      const scaleLine = this.state.scaleLine[0].points;
      if (isValidInteger) {
          popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save the change?', 300, () => {
            doSaveScaleData(authToken, mappingInteriorGraph.id, this.state.lineLength, scaleLine.join());
          }, null, false);
      } else {
        openModalAlert("The line length (scale) value is invalid.");
      }
    } else {
      openModalAlert("Sorry you don't have permission to change config.");
    }
  }
}

const mapStateToProps = (state) => {
  return {
    accountRole: state.loginReducers.accountRole,
    roleTableAuth: state.loginReducers.roleTableAuth,
    mappingOrg: state.visualReducers.mappingOrg,
    mappingGroup: state.visualReducers.mappingGroup,
    virtualDeviceInfo: state.visualReducers.virtualDeviceInfo,
    wallInfo: state.visualReducers.wallInfo,
    mappingInteriorGraph: state.visualReducers.mappingInteriorGraph,
    interiorGraphImgUrl: state.visualReducers.interiorGraphImgUrl,
    interiorGraphImgWidth: state.visualReducers.interiorGraphImgWidth,
    accountInfo: state.loginReducers.accountInfo,
    authToken: state.loginReducers.authToken,
    selectSite: state.siteReducers.selectSite,
    status: state.visualReducers.status,
    heatmapData: state.visualReducers.heatmapData,
    recommendedChannels: state.visualReducers.channels,
    heatmapAllData: state.visualReducers.heatmapAllData,
    popLoading: state.visualReducers.popLoading,
    deviceList: state.visualReducers.deviceList,
    selectFloorPlanProject: state.visualReducers.selectFloorPlanProject,
    selectFloorPlanProjectEnvironment: state.visualReducers.selectFloorPlanProjectEnvironment,
    graphId: state.visualReducers.graphId,
    activePage: state.menuReducers.activePage,
    selectGraph: state.visualReducers.graphId,
    visualListId: state.visualReducers.visualListId,
    isLoadingProject: state.visualReducers.isLoadingProject,
    isLoadingFloorData: state.visualReducers.isLoadingFloorData,
    nextFloorPlanId: state.visualReducers.nextFloorPlanId,
    deviceVirtualList: state.visualReducers.deviceVirtual,
    floorPlanData: state.visualReducers.floorPlanData,
  }
}

export default withRouter(connect(
    mapStateToProps,
    {
      doActivePage,
      popupModalConfirm,
      getVisualGroupRSSIAction,
      getVisualGroupInteriorGraphAction,
      openPickModalWithAction,
      deviceDataSuccessAction,
      openModalAlert,
      openModalTip,
      closeModal,
      doGetHeatmapData,
      doGetHeatmapAllData,
      doGetVisualData,
      doSaveVisualGraphData,
      doSaveScaleData,
      doSaveChannelRecommendation,
      doGetInteriorGraph,
      doGetAvaliableDeviceData,
      doGetVirtualDeviceData,
      doDeleteVirtualDeviceInfo,
      dispathVisualMangerDetail,
      openModal,
      doGetFloorDetail,
      continueToChangeFloorPlan,
      endChangingFloorPlan,
      doGetVisualDataId,
      doGetFloorPlanProjectList,
    }
)(VisualBlueprint));




